<i18n>{
  "fr": {
    "title": "Conditions Générales de Ventes",
    "tac-flight": {
      "title": "CONDITIONS GÉNÉRALES DE VENTE VOLS SECS",
      "contact-information": {
        "1": "airbus-staffcouncil.amplitudes.com est un service du groupe Amplitudes",
        "2": "AMPLITUDES, 20 rue du Rempart Saint-Etienne - 31 000 Toulouse – Vigma SAS au capital de 550 000 euros – Siret 380 775 122 00035 RCS B 380 775 122 Code APE 7911 Z."
      },
      "article": {
        "1": {
          "title": "Article 1. Définitions et champs d'application",
          "section": {
            "1": {
              "title": "1.1 Définitions",
              "text": {
                "1": "Les définitions citées ci-dessous gardent la même signification au singulier et au pluriel.",
                "2": "Certaines sont issues du Règlement Européen n° 261/2004.",
                "3": "PARTENAIRE",
                "4": "Désigne tous les fournisseurs qui livrent une prestation.",
                "5": "PRESTATION",
                "6": "Désigne les prestations de services proposées sur le site: airbus-staffcouncil.amplitudes.com",
                "7": "SITE",
                "8": "Désigne le site internet: airbus-staffcouncil.amplitudes.com",
                "9": "UTILISATEUR",
                "10": "Désigne toute personne qui consulte le site, réserve et/ou achète une ou plusieurs prestations.",
                "11": "TRANSPORTEUR AÉRIEN",
                "12": "Désigne les compagnies opérant des services de transport aérien, et possédant une licence d'exploitation en cours de validité.",
                "13": "RÉSERVATION",
                "14": "Désigne la prise en compte et la confirmation par un transporteur aérien, ou un agent agréé, d’une demande de transport effectuée par un utilisateur sur le site internet.",
                "15": "TARIF/TARIFAIRE",
                "16": "Désigne les conditions tarifaires que le transporteur aérien a publié et déposé, le cas échéant, auprès des autorités compétentes.",
                "17": "BILLET",
                "18": "Désigne un document en cours de validité, matériel ou immatériel, donnant droit au client à un transport, et qui a été délivré ou autorisé par le transporteur aérien ou son agent agréé.",
                "19": "PASSAGER",
                "20": "Désigne la personne transportée, ou devant l’être, et qui s’est préalablement acquittée d’un billet en cours de validité; ou dans le cas d’un remboursement, la personne ayant payé le billet.",
                "21": "BÉNÉFICIAIRE/ASSURÉ",
                "22": "Désigne une personne, ou un groupe de personne, ayant souscrit au contrat d’assurance proposé par Amplitudes."
              }
            },
            "2": {
              "title": "1.2 Champ d'application",
              "text": {
                "1": "Les présentes Conditions générales de vente régissent l’offre et la fourniture des prestations proposées sur le site airbus-staffcouncil.amplitudes.com.",
                "2": "Avant de pouvoir procéder à un achat, l’utilisateur doit avoir pris connaissance dans leur intégralité des Conditions générales de vente et de la Politique de confidentialité des données personnelles collectées, et les avoir acceptées en cochant la case ou en cliquant sur les liens prévus à cet effet. Le processus de réservation ne pourra pas se faire sans cette acceptation. L’utilisateur doit donc finaliser le processus de réservation sur le site en prenant connaissance et en acceptant les présentes Conditions générales de vente et la Politique de confidentialité des données collectées.",
                "3": "Les Conditions spécifiques des partenaires s’appliquent également à l’offre et à la fourniture des prestations selon les mêmes modalités que les Conditions générales de vente. Il incombe à l’utilisateur de prendre connaissance des Conditions spécifiques du partenaire concerné et des Conditions spécifiques des prestations en les consultant sur le lien: ",
                "3-href": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "4": "Amplitudes se réserve le droit de modifier à tout moment et sans préavis les présentes Conditions générales de vente. Ces modifications ne concerneront pas les réservations de prestations réalisées antérieurement. Il est donc important que lors de son achat, l’utilisateur s’assure des dispositions en vigueur en prenant connaissance des Conditions générales de vente avant de les accepter."
              }
            }
          }
        },
        "2": {
          "title": "Article 2. Conditions de réservation",
          "section": {
            "1": {
              "title": "2.1 Utilisation du site",
              "text": {
                "1": "Le site permet à l’utilisateur de rechercher des prestations de transport aérien, d’effectuer des réservations, et de conclure une transaction avec les partenaires. Nous rappelons ici que les mineurs ne sont pas autorisés à effectuer une quelconque réservation sur le site d’airbus-staffcouncil.amplitudes.com. De plus l’utilisateur doit être juridiquement capable d’utiliser le site.",
                "2": "L’utilisateur est responsable des démarches financières qu’il entreprend sur le site airbus-staffcouncil.amplitudes.com. Il est donc tenu de veiller à l’utilisation qui est faite de son nom d’utilisateur et de son mot de passe. En cas de fraude, il appartient à l’utilisateur de rapporter la preuve du délit. Il doit également garantir la véracité et l'exactitude des informations le concernant renseignées sur le site.",
                "3": "En cas d’utilisation frauduleuse du site, ou qui ne respecterait pas les présentes Conditions générales de vente, Amplitudes se réserve le droit de refuser à un utilisateur l’accès aux prestations proposées par Amplitudes, et/ou par ses partenaires, ainsi qu’aux autres fonctionnalités du site."
              }
            },
            "2": {
              "title": "2.2 – Modalités d’accès à un transport aérien",
              "sub-section": {
                "1": {
                  "title": "2.2.1. Responsabilités et obligations du passager",
                  "sub-sub-section": {
                    "1": {
                      "title": "2.2.1.1. Formalités administratives",
                      "text": {
                        "1": "L’utilisateur peut trouver toutes les informations concernant les formalités administratives nécessaires à l’exécution de son voyage sur le site: ",
                        "1-link": "http://www.diplomatie.gouv.fr/fr/",
                        "2": "Il est de la responsabilité de l’utilisateur d’en prendre connaissance. Lors du consentement aux présentes Conditions générales de vente, l’utilisateur reconnait s’être informé sur les formalités administratives à suivre pour pouvoir voyager.",
                        "3": "Le passager est tenu de s’informer sur les conditions d’entrée sur le territoire du pays dans lequel il se rend et de s’y conformer. Il en va de même pour les pays qu’il quitte, qu’il traverse par avion, ou dans lequel il se trouve en qualité de passager en transit. Il doit également connaître l’ensemble des lois, règlements ou actes qui régissent le pays, et s’y conformer.",
                        "4": "Avant d’entreprendre un voyage vers des destinations internationales, Amplitudes conseille à ses utilisateurs de consulter les interdictions de voyager, alertes, annonces et conseils publiés par les gouvernements concernés. Vous trouverez des conseils aux voyageurs en fonction des pays sur le site internet de France Diplomatie: ",
                        "4-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays/",
                        "5": "En proposant des produits de voyage dans certaines destinations internationales, Amplitudes ne garantit pas que le voyage dans ces zones soit recommandé ou ne présente aucun risque.",
                        "6": "Lors de son enregistrement et de son embarquement, le passager doit être en mesure de présenter au transporteur les documents exigés par les conditions d’entrée du territoire (passeport, visa, certificat sanitaire et autres). Ceux-ci doivent impérativement être en règle et valides. En fonction de la loi et des règlementations en vigueur, les douaniers et autres agents agréés peuvent éventuellement demander au passager d’être présent lors de l’inspection de ses bagages.",
                        "7": "Passeport",
                        "8": "Il est conseillé aux ressortissants français de s’informer sur les exigences applicables concernant les passeports en consultant le site de France Diplomatie: ",
                        "8-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/infos-pratiques-20973/preparer-son-depart-20975/formalites-administratives/article/formalites-administratives",
                        "9": "Rappelons que dans certains pays la règlementation impose que le passeport du passager ait une validité supérieure à 6 mois à partir de la date d'entrée sur le territoire. Par conséquence, Amplitudes recommande donc aux utilisateurs de vérifier la date de validité de leur passeport, et de prendre connaissance des exigences applicables du pays de destination, avant de finaliser leur projet de voyage.",
                        "10": "Le nom du passeport doit impérativement correspondre au nom indiqué sur le billet, autrement l’utilisateur ne pourra pas voyager avec les transporteurs aériens, et il ne pourra pas non plus faire fonctionner l’éventuelle assurance à laquelle il aurait souscrit. Toutefois, si un passager change de nom de famille pour une quelconque raison après la réservation, mais avant le départ, il est prié d’en informer au plus vite Amplitudes afin de faire le nécessaire pour que le voyage se déroule sans problème.",
                        "11": "Rappelons également que les enfants doivent être impérativement en possession de papiers d'identité en cours de validité et à leur nom, et cela quel que soit leur âge.",
                        "12": "Visa",
                        "13": "Pour toute information concernant les visas, il est conseillé aux utilisateurs de contacter l'ambassade du pays qu'ils envisagent de visiter. L’obtention d’un visa peut prendre un certain temps, nous recommandons aux utilisateurs de faire les démarches nécessaires suffisamment à l’avance.",
                        "14": "Il arrive que les conditions d'obtention d'un visa changent, c’est pourquoi il est conseillé de vérifier que les informations obtenues soient d’actualité avant de procéder à la réservation, et également avant votre départ. Amplitudes ne pourra être tenu pour responsable si le passager se voit refuser l’entrée dans un avion ou un pays, en raison de son incapacité à présenter un passeport ou visa adéquat, ou tout autre document de voyage exigé par la compagnie aérienne, les autorités ou la règlementation du pays. Cela inclut tous les transits et les arrêts effectués par l'avion, même si le passager ne quitte pas l'avion ou l'aéroport.",
                        "15": "ESTA",
                        "16": "Pour entrer aux Etats-Unis, ou pour y effectuer un transit, avec le Programme d’exemption de visa, le voyageur doit demander à voyager sous le système électronique d'autorisation de voyage (Electronic System for Travel Authorization ou ESTA). Pensez à effectuer votre demande d'ESTA suffisamment à l’avance. Il est conseillé de faire les démarches pour une demande d’ESTA au moins 72 heures avant le départ. Pour plus d'information, consultez le site internet du Département américain de la sécurité intérieure: ",
                        "16-link": "https://esta.cbp.dhs.gov/esta"
                      }
                    },
                    "2": {
                      "title": "2.2.1.2 Formalités sanitaires",
                      "text": {
                        "1": "Il est de la responsabilité de l’utilisateur de prendre connaissance des formalités sanitaires nécessaires à l’exécution de son voyage en les consultant sur le site ",
                        "1-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/",
                        "1-end": "Lors du consentement aux présentes Conditions générales de vente, l’utilisateur reconnait s’être informé sur les formalités sanitaires à suivre pour pouvoir voyager.",
                        "2": "Vaccination et conseils médicaux",
                        "3": "Il peut être demandé aux voyageurs pour certaines destinations de faire des vaccins. Toutefois les recommandations peuvent changer. C’est pourquoi il est conseillé de consulter un médecin avant le départ pour un voyage afin de s’informer sur les recommandations en vigueur. Il est de la responsabilité du voyageur de s’assurer qu’il respecte toutes les conditions d’entrée sur le territoire liées à la santé. Il doit donc avoir obtenu toutes les inoculations obligatoires ou recommandées, veiller à prendre les médicaments requis, et suivre les instructions du médecin. Vous pouvez trouver des conseils médicaux sur le site: ",
                        "3-link": "http://www.pasteur.fr/fr/map",
                        "4": "Règlementation sur la désinsectisation",
                        "5": "Certains pays se réservent le droit de désinsectiser l’avion s’ils considèrent qu’il y a une menace pour la santé publique, l’agriculture ou l’environnement. L'Organisation mondiale de la santé et l'Organisation internationale de l'aviation civile ont approuvé les procédures de désinsectisation suivantes:",
                        "6": "Vaporiser la cabine de l'avion avec un aérosol insecticide pendant que les passagers sont à bord de l'avion",
                        "7": "Traiter les surfaces intérieures de l'avion avec un insecticide résiduel lorsqu'aucun passager n'est à bord de l'avion",
                        "8": "Pour plus d'informations, veuillez consulter le site de la DGAC (Direction générale de l'aviation civile): ",
                        "8-link": "http://www.developpement-durable.gouv.fr/-Passagers-aeriens-s-informer-pour-.html",
                        "9": ", ou le site du Ministère de la santé: ",
                        "9-link": "http://www.sante.gouv.fr/controle-sanitaire-dans-les-aeroports.html"
                      }
                    }
                  }
                },
                "2": {
                  "title": "2.2.2 Limites de responsabilités et obligations d’Amplitudes et de ses partenaires",
                  "text": {
                    "1": "Ni Amplitudes, ni le transporteur, ne pourront être tenus pour responsable si le passager:",
                    "2": "N’est pas en mesure de présenter les documents de voyage exigés par la règlementation (passeports, visas, certificats de bonne santé et autres);",
                    "3": "Est en possession de documents de voyage (passeports, visas ou certificats de bonne santé ou autres documents) invalides ou périmés;",
                    "4": "N’a pas respecté les lois, règlementations et actes en vigueur;",
                    "5": "N’était pas présent lors du contrôle douanier de ses bagages et qu’un dommage a été subi au cours de l’inspection."
                  }
                },
                "3": {
                  "title": "2.2.3 Refus à l’entrée d’un territoire",
                  "text": {
                    "1": "Ni Amplitudes, ni le transporteur ne pourront être tenu pour responsables si le passager se voit refuser par les autorités et le gouvernement l’entrée sur le territoire. De ce fait, il incombera au passager d’assumer les conséquences directes et indirectes de ce refus. Tous les frais qui en résulteraient seront donc à la charge du passager, ce qui comprend:",
                    "2": "Toute amende, pénalité ou charge qui serait réclamée au transporteur par le gouvernement en raison de ce refus;",
                    "3": "Tous frais de détention qui seraient facturés au transporteur;",
                    "4": "Le prix du billet de transport qui a servi à ramener le passager chez lui;",
                    "5": "Tout autre coût que le transporteur serait amené à assumer, ou dont il conviendrait avec les autorités et/ou le gouvernement du pays de payer.",
                    "6": "Dans le cas où l’entrée du territoire aurait été refusé à un passager, ni Amplitudes, ni le transporteur ne seront tenus de lui rembourser le billet de transport vers le pays de destination."
                  }
                },
                "4": {
                  "title": "2.2.4 Remboursement des amendes, frais de détention et autres charges",
                  "text": {
                    "1": "S’il ne respecte pas les lois, les règlements ou les autres obligations en vigueur en ce qui concerne le voyage ou l’entrée sur le territoire du pays de destination, le passager est tenu de s’acquitter de la totalité des amendes, pénalités, frais, ou coûts payés par le transporteur en raison du non-respect de ces lois, règlements et obligations. Cela est également valable si le passager ne présente pas les documents de voyage adéquats et nécessaires requis par le pays."
                  }
                },
                "5": {
                  "title": "2.2.5 Inspections des douanes, de la police ou d’autres autorités publiques, et contrôle de sécurité",
                  "text": {
                    "1": "Lorsque les lois, règlementations ou actes l’exigent, le service des douanes, ou d’autres fonctionnaires ou agents publics compétents, peuvent demander au passager d’être présent lors de l’inspection de ses bagages. Le transporteur ne pourra pas être tenu pour responsable des dommages directs ou indirects subis par le passager et/ou ses bagages lors d'une inspection, ni du fait de l’absence du passager lors de celle-ci.",
                    "2": "En acceptant les présentes Conditions générales de vente, le passager autorise, pour des raisons de sécurité et de sûreté, les fonctionnaires, les agents publics, les agents des autorités aéroportuaires ou le transporteur et ses agents agréés, à réaliser des contrôles de sécurité sur lui ou ses bagages, et s’engage à ne pas s’y opposer."
                  }
                }
              }
            },
            "3": {
              "title": "2.3 Passation et annulation de réservations",
              "text": {
                "1": "Amplitudes transmettra à l’utilisateur la confirmation de réservation dans un délai minimum de 1 jour ouvré après la date de réservation. La confirmation de réservation se compose de l’identification de la prestation réservée (ou des prestations s’il y en a plusieurs) et le prix.",
                "2": "Toutes les conditions d'annulation, de rectification des réservations ou de remboursement sont disponibles sur ",
                "2-link": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "3": "Toute demande d’annulation ou de modification doit être transmise à Amplitudes par courrier électronique à l’adresse: ",
                "3-link": "airbus@amplitudes.com",
                "4": "Amplitudes prendra en charge toutes les requêtes au nom des partenaires concernés. L’utilisateur ne dispose pas d’un droit d’annulation automatique. Les Conditions spécifiques des partenaires sont accessibles sur leurs sites respectifs que l’utilisateur peut aller les consulter avant de réserver. Toute annulation totale ou partielle d’une réservation est soumise aux Conditions spécifiques du partenaire concerné.",
                "5": "Par ailleurs, en cas d'annulation totale ou partielle d’une réservation du fait de l'utilisateur, du prestataire ou d’une décision administrative en France ou dans un des pays de destination ou de transit, les frais d’émission initiaux des titres de transport ne sont remboursables en aucun cas.",
                "6": "D’autre part, des frais de mise en remboursement et d’établissement d’un avoir de 10€ par billet seront déduits des montants remboursés par le prestataire.",
                "7": "Il peut lui être demandé par le partenaire concerné de régler certains frais. Si l’annulation concerne plusieurs personnes, tout frais d'annulation applicable sera assigné respectivement à chaque personne concernée. Dans certains cas, la compensation à verser aux partenaires pour l’annulation pourra être égale au montant total du voyage réservé, et l’utilisateur ne pourra pas demander un remboursement à ce titre.",
                "8": "Aucun remboursement ne pourra être réclamé si l’utilisateur ne se présente pas au départ du voyage.",
                "9": "Lorsqu’Amplitudes modifie une réservation pour l’utilisateur, il arrive qu’il doive annuler la réservation initiale. Dans ce cas des frais d’annulation de 10€ par billet seront appliqués de même que des frais d’émissions pour les nouveaux billets. Toute annulation peut également entraîner un paiement de compensation et/ou des frais établis par les Conditions spécifiques du partenaire. Ces frais peuvent être égaux à la valeur totale du voyage réservé. L’utilisateur est alors tenu de payer les frais de sa nouvelle réservation.",
                "10": "À défaut des dispositions particulières mentionnées préalablement sur le site, toute modification ou toute annulation émanant de l'utilisateur (à l’exception des cas de force majeure et sauf accord favorable du partenaire concerné) entraîne la perception d'une indemnité d'un montant équivalent à la totalité du prix de la prestation, sans préjudice de l’application de frais de dossier dans le cas d’une annulation ou une modification dans les conditions définies ci-dessus. De ce fait, le remboursement du billet d'avion ne pourra être accordé qu'avec l'accord préalable du partenaire concerné.",
                "11": "Lorsqu’un billet a été réémis suite à une annulation ou modification émanant de l’utilisateur, le prix du nouveau billet peut s’avérer être plus élevé que celui du billet initial. La différence de prix sera donc à régler par l’utilisateur. Dans ce cas Amplitudes facturera à l’utilisateur des frais de mise en remboursement de 10€ par billet ainsi que des frais d’émission selon le barème contractuel de l’AISC, conformément aux stipulations du présent article.",
                "12": "En cas de remboursement de l'utilisateur, les sommes préalablement versées seront recréditées sur le compte de l’AISC.",
                "13": "Si le titre de transport est invalide, ou s’il n’a pas permis au passager de bénéficier du transport aérien, ce dernier peut demander un remboursement de la totalité, ou d’une partie, des taxes aériennes et redevances passagères incluses dans le prix du billet. Le remboursement se fera dans la limite des taxes aéroportuaires et redevances passagères remboursées par le partenaire, des éventuels frais de mise en remboursement prélevés par celui-ci et des frais de mise en remboursement Amplitudes de 10€ par billet.",
                "14": "L’utilisateur recevra le remboursement des taxes et redevances au plus tard 30 jours après la date de réception de la demande. Pour nous faire parvenir sa demande de remboursement, il doit l’envoyer par courrier électronique à l’adresse: ",
                "14-link": "airbus@amplitudes.com",
                "15": "Si l’utilisateur fait parvenir sa demande de remboursement par un autre moyen que celui spécifié ci-dessus, il lui sera facturé des frais de traitement dans la limite de 20% de la somme remboursée.",
                "16": "L’utilisateur ne pourra obtenir le remboursement qu’une seule fois. Tout remboursement est soumis aux Conditions spécifiques du partenaire concerné, et tient compte de la limite des sommes autorisées par ledit partenaire."
              }
            },
            "4": {
              "title": "2.4 Convocation et retrait des documents de voyage",
              "text": {
                "1": "Tous les documents de voyage sont envoyés par messagerie électronique à l'adresse mentionnée par l'utilisateur lors de sa réservation sur le site.",
                "2": "Toutefois si Amplitudes ne parvient pas à envoyer les documents de voyage à l’utilisateur en raison d’une erreur de ce dernier dans la saisie de ses coordonnées, ni Amplitudes ni le partenaire concerné ne pourront être tenu pour responsables."
              }
            },
            "5": {
              "title": "2.5 Preuve de la réservation",
              "text": "Il est entendu que les données conservées dans le système d'information d’Amplitudes et/ou de ses partenaires ont force probante en ce qui concerne les réservations, excepté dans le cas d’une erreur manifeste de la part d’Amplitudes ou des partenaires dont l'utilisateur rapporterait la preuve. Les données sur support informatique ou électronique constituent des preuves valables et en tant que telles, et sont recevables dans les mêmes conditions et avec la même force probante que tout autre document établi, reçu ou conservé par écrit."
            },
            "6": {
              "title": "2.6 Droit de rétractation",
              "text": {
                "1": "Compte tenu de l'article L.121-21-8° du Code de la consommation, et en accord avec le Code de la consommation en matière de vente à distance, les prestations proposées par Amplitudes, en son nom ou au nom de ses partenaires ne sont pas soumises à l'application du droit de rétractation prévu aux articles L121-21.",
                "2": "Par conséquence, toutes les prestations réservées sur le site d’Amplitudes sont soumises aux conditions d’annulation et de modification prévues dans les présentes Conditions générales de vente et/ou dans les Conditions spécifiques des partenaires en vigueur."
              }
            }
          }
        },
        "3": {
          "title": "Article 3. Le Transport Aérien",
          "text": {
            "1": "Les prestations de transport aérien sont proposées seules."
          },
          "section": {
            "1": {
              "title": "3.1 Conditions de voyages",
              "text": {
                "1": "Les conditions d'exécution des transports aériens sont régies par les Conditions spécifiques des compagnies aériennes ou des partenaires (notamment les conditions de transport et les conditions tarifaires). Selon les cas les Conditions spécifiques peuvent prévoir des restrictions sur les frais d’annulation ou de modification d'une réservation. Les Conditions Spécifiques des partenaires fournissant des prestations de transport aérien sur le site d’Amplitudes sont disponibles sur le site: ",
                "1-link": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "2": "L’AISC paye directement Amplitudes pour les réservations de billets d'avion des utilisateurs, de ce fait Amplitudes agit en qualité de mandataire du partenaire fournissant les prestations de transport aérien pour les compagnies aériennes membres du Billing and Settlement Plan (autres que low cost). Autrement dit le contrat de l'utilisateur pour les prestations de transport aérien qu’il a commandé est signé entre l'utilisateur et le partenaire fournissant lesdites prestations."
              }
            },
            "2": {
              "title": "3.2 Conditions spécifiques des Compagnies aériennes",
              "text": {
                "1": "Tout transport aérien est soumis aux Conditions spécifiques de la compagnie aérienne concernée. Celles-ci permettent de mettre en place les conditions de responsabilité et les mesures mises en place pour les personnes en situation de handicap, à mobilité réduite ou à forte corpulence, les enfants, les femmes enceintes, le transport de bagage (notamment pour les objets et substances interdits en soute, la franchise bagage et le tarif des excédents bagage), les transports d’animaux et autres.",
                "2": "Pour toute question relative à ces Conditions spécifiques, l’utilisateur doit se reporter aux Conditions générales de transport disponibles sur les sites de chaque compagnie aérienne.",
                "3": "L’utilisateur est tenu de respecter les consignes des compagnies aériennes et des partenaires, notamment en ce qui concerne les délais de présentation pour l'enregistrement. Nous conseillons aux voyageurs de se présenter à l'enregistrement au moins trois heures avant le départ de l'avion pour les vols internationaux et au moins deux heures et demie à l'avance pour les vols intérieurs."
              }
            },
            "3": {
              "title": "3.3 Responsabilité des transporteurs aériens",
              "text": "Nous rappelons que la responsabilité des transporteurs aériens se trouve souvent limitée par le droit national ou international qui leur est applicable, ou par leurs propres Conditions spécifiques qui leurs sont également applicables de plein droit."
            },
            "4": {
              "title": "3.4 Règlementation sur l’identité du transporteur aérien",
              "text": {
                "1": "Il arrive parfois que l’utilisateur ait acheté un billet de transport sur une compagnie aérienne, mais qu’il voyage avec une autre. C'est le cas par exemple lorsque le premier transporteur (le transporteur contractuel, qui est responsable du voyage) a affrété un vol de la seconde compagnie (le transporteur de fait, qui assure le vol) ou conclu avec elle un accord de partage de code.",
                "2": "Le vendeur a le devoir d’informer par écrit l’utilisateur sur l'identité du transporteur contractuel et du (des) transporteur(s) de fait, avant et au moment de l'achat du billet, selon les articles R. 322-1 à R. 322-7 du code de l'aviation civile.",
                "3": "Si le vol affrété est non régulier, alors la liste peut contenir jusqu’à cinq transporteurs. Si le choix du (des) transporteur(s) est ensuite modifié, le vendeur est tenu d’en informer les voyageurs dès que possible, ou au plus tard avant l'enregistrement, ou avant les opérations d'embarquement dans le cas d’une correspondance sans enregistrement préalable. Un changement du choix de transporteur ne pourra pas être considéré comme un motif valable pour demander une annulation et un remboursement, sauf si le transporteur de fait se trouve sur la liste noire européenne selon l’article 3, rubrique 3.11."
              }
            },
            "5": {
              "title": "3.5 Identité des passagers",
              "text": {
                "1": "Le nom et le prénom qui ont été renseigné au moment de la réservation doivent correspondre strictement à ce qui est indiqué sur les papiers d’identité en cours de validité qui seront présentés lors de l’enregistrement et de l’embarquement.",
                "2": "Pour les trajets aériens comportant un survol de l’espace aérien américain, plus particulièrement pour les Etats-Unis, le Canada, le Mexique et Cuba, il y a certaines recommandations que l’utilisateur doit prendre en compte. Pour les documents administratifs nécessaires au voyage, les autorités américaines recommandent aux femmes mariées d’utiliser leur nom de jeune fille. Il doit être renseigné sur le billet d’avion et le formulaire ESTA, ainsi que sur les différentes formalités de sécurité obligatoires pour l’accès ou le transit aux Etats-Unis."
              }
            },
            "6": {
              "title": "3.6 Bébés, enfants et femmes enceintes",
              "text": {
                "1": "Les compagnies aériennes se réservent le droit de refuser l’accès au transport aux femmes enceintes s’ils considèrent qu’il y a un risque en raison du terme de grossesse. Toutes les informations concernant le transport des femmes enceintes se trouvent dans les Conditions spécifiques du partenaire. L’utilisateur est tenu d’en prendre connaissance si nécessaire et de les respecter.",
                "2": "Dans le cas d’un voyage avec un enfant ou un bébé, l’utilisateur est tenu de prendre connaissance des Conditions spécifiques du partenaire concernant le transport des enfants et des bébés, et de les respecter. Les enfants de moins de 2 ans ne disposent pas de siège dans l'avion, sauf si les parents en font la demande et payent une place supplémentaire. Précisons ici que cette disposition n’est valable que si l’enfant a moins de 2 ans pendant toute la période du voyage. Autrement dit, si l’enfant dépasse l’âge de 2 ans avant la date de retour, il devra voyager avec un billet aller-retour au tarif enfant, et disposera donc d’un siège dans l’avion. En cas de non-respect de cette règle, aucun remboursement ne pourra être réclamé pour les frais occasionnés.",
                "3": "Les enfants de moins de 14 ans non accompagnés ne seront acceptés sur le vol que si les Conditions spécifiques du partenaire le permettent.",
                "4": "Les enfants doivent être impérativement en possession de papiers d'identité en cours de validité et à leur nom, et cela quel que soit leur âge."
              }
            },
            "7": {
              "title": "3.7 Quelques précisions à l’attention de l’utilisateur",
              "text": {
                "1": "Amplitudes n’a pas la possibilité de décider de l’attribution d’un siège, même lorsqu’il a été réservé avec la compagnie aérienne. Amplitudes ne peut donc en aucun cas garantir que certains sièges soient disponibles le jour du départ.",
                "2": "Les informations concernant le temps de trajet dans l’avion sont fournies par le partenaire à titre indicatif, et sont susceptibles d’être modifiées ou confirmées. Amplitudes n’a aucun contrôle sur ces informations, et ne pourra donc pas en assumer la responsabilité.",
                "3": "Dans le cas où l’utilisateur a réservé un vol aller-retour, mais n’a pas utilisé le vol aller, les compagnies aériennes se réservent le droit, selon les conditions, d’annuler le vol de retour sans aucun remboursement. Il en va de même si l’utilisateur n’a pas pris le vol de retour qu’il a réservé. Les coupons de vols doivent impérativement être utilisés dans l'ordre chronologique, conformément aux dates du parcours renseignées dans la réservation. Toute utilisation non conforme du billet entrainera le paiement d’un supplément prix variable en fonction des Conditions spécifiques du partenaire.",
                "4": "S’il s’agit d’un vol spécifique ou charter, le nom de la compagnie aérienne, les horaires de vol, le type d'avion, l'itinéraire et les éventuels arrêts intermédiaires sont fournis à titre exclusivement indicatif.",
                "5": "Certaines compagnies aériennes facturent des frais supplémentaires pour le repas, les bagages ou encore la sélection des sièges. Amplitudes ne pourra pas être tenu pour responsable de ces frais. Toute information sur le site concernant ces frais sont donnés à titre indicatif, et sont susceptibles d’être modifiées à tout moment par les compagnies aériennes.",
                "6": "Lorsque la ville de destination comporte plusieurs aéroports, alors le nom de l’aéroport est renseigné à titre indicatif et est susceptible d’être modifié.",
                "7": "Il est recommandé à l’utilisateur de veiller à prévoir un délai suffisant lors de la réservation pour ne pas avoir de retard si le voyage comprend une correspondance, un transit, ou un changement d’aéroport."
              }
            },
            "8": {
              "title": "3.8 Billets",
              "sub-section": {
                "1": {
                  "title": "3.8.1 Propriétés des billets",
                  "text": {
                    "1": "Les billets fournis à l’utilisateur sont nominatifs. Rappelons ici que seul le passager dont le nom est renseigné sur le billet peut bénéficier de la prestation fournie par le transporteur aérien. L’identité du détenteur du billet peut être vérifiée à tout moment.",
                    "2": "Le passager qui détient le billet n’est pas autorisé à le transférer ou à le céder à qui que ce soit, sauf disposition contraire conformément aux conditions.",
                    "3": "Le billet est, et demeure à tout moment, la propriété du transporteur."
                  }
                },
                "2": {
                  "title": "3.8.2 Billet électronique",
                  "text": {
                    "1": "Le billet électronique est un billet non matérialisé. Pour obtenir sa carte d’embarquement, le passager doit se présenter au comptoir d’embarquement de la compagnie aérienne concernée, muni de ses documents de voyage. Il est donc important de respecte r les délais impartis pour l'enregistrement. L’utilisateur peut également effectuer son enregistrement sur le site du partenaire, mais cette manœuvre reste sous sa seule responsabilité. Dans ce cas, il est recommandé de consulter préalablement les conditions spécifiques à cet enregistrement.",
                    "2": "Amplitudes propose parfois à ses utilisateurs de réserver une combinaison de deux billets simples au lieu d’un billet aller-retour. Cette offre permet de proposer un plus large choix de billets d'avion, et souvent à un prix inférieur. Les billets peuvent alors être combinés sur une même compagnie aérienne ou sur deux compagnies différentes.",
                    "3": "Contrairement aux billets aller-retour, le billet simple est soumis à ses propres règles, limitations et frais. Autrement dit, lorsque l’utilisateur réserve deux billets simples, un contrat spécifique est mis en place avec chacun des partenaires, et l’utilisateur sera soumis aux Conditions spécifiques de chaque partenaire.",
                    "4": "Dans le cas où l'un de ces deux vols est modifié par la compagnie aérienne (par exemple à cause d’une annulation ou d’un report) obligeant ainsi l'utilisateur à modifier son autre billet d'avion, ce dernier prendra en charge la totalité des frais liés aux modifications apportées à ce billet d'avion."
                  }
                },
                "3": {
                  "title": "3.8.3 Modification d’un billet",
                  "text": {
                    "1": "Toute demande de modification de billet doit se faire auprès d’Amplitudes par courrier électronique à l’adresse ",
                    "1-link": "airbus@amplitudes.com",
                    "2": " ou par téléphone au numéro indiqué sur la page d’accueil du site. Amplitudes sollicitera s’il y a lieu l’accord du transporteur ou de l’agent agréé, et agira en fonction des modalités et tarifs définis par le transporteur ou l’agent agréé.",
                    "3": "La modification d’un billet suppose l’annulation de la réservation initiale et une nouvelle réservation. A ce titre, des frais d’annulation de 10€ par billet ainsi que des frais d’émission du nouveau billet selon le barème contractuel établi pour l’AISC seront facturés par Amplitudes.",
                    "4": "Par ailleurs, plusieurs tarifs ne sont exclusivement valables que pour les dates et vols indiqués sur le billet, et ne peuvent donc être modifiés, à moins de payer un complément tarifaire. Il est de la responsabilité de l’utilisateur de se renseigner auprès d’Amplitudes sur les conditions de modification applicables à son billet."
                  }
                }
              }
            },
            "9": {
              "title": "3.9 Taxes de transport",
              "text": "Les taxes sont fixées par le gouvernement du pays. Elles incluent les redevances passagères et les taxes aéroportuaires. Il est obligatoire de payer les taxes de transport lors de la réservation d’un vol."
            },
            "10": {
              "title": "3.10 Bagages",
              "sub-section": {
                "1": {
                  "title": "3.10.1 Franchise de bagages",
                  "text": "Le passager est autorisé à voyager en franchise d’une quantité de bagages (en nombre ou en poids). La franchise est renseignée sur le billet, ou sur l’itinéraire et le reçu s’il s’agit d'un billet électronique ou d'un titre de transport. La franchise des bagages dépend de chaque transporteur."
                },
                "2": {
                  "title": "3.10.2 Excédent de bagages",
                  "text": {
                    "1": "Si les bagages enregistrés dépassent les limites de poids et de dimensions autorisées par le transporteur, il sera demandé au passager de payer un supplément tarifaire. Les informations concernant l’excédent de bagages et le supplément tarifaire (montants et modalités de paiement) sont disponibles auprès du transporteur ou des agents agréés.",
                    "2": "Rappelons ici que pour des raisons de sécurité, les bagages ne doivent pas dépasser le poids maximal fixé par le transporteur."
                  }
                },
                "3": {
                  "title": "3.10.3 Articles dangereux",
                  "text": {
                    "1": "Il est strictement interdit de prendre avec soi à bord de l'aéronef tout article que le transporteur estime susceptible de porter atteinte à la sécurité de l'aéronef, des biens ou de toute personne à bord.",
                    "2": "Il est interdit d’introduire dans la cabine de l'aéronef une arme à feu, ou tout autre type d’arme, ancienne ou récente, ni même une réplique de ces types d'armes, comme par exemple un jouet.",
                    "3": "Il est également interdit d’introduire dans la cabine de l'aéronef une épée, un couteau, un arc, une flèche, ou toute autre arme ou objet similaire."
                  }
                },
                "4": {
                  "title": "3.10.4 Conditions de refus de transport des bagages enregistrés ",
                  "text": "Le transporteur se réserve le droit de refuser des bagages enregistrés s’il considère qu’ils ne sont pas conditionnés convenablement et de manière sûre dans des contenants adaptés."
                },
                "5": {
                  "title": "3.10.5 Fouilles, contrôles et radiographies des passagers et des bagages",
                  "text": {
                    "1": "Pour des raisons de sécurité, le transporteur, ou un agent agréé, peut exercer une fouille ou un contrôle sur le passager. Il peut également procéder à une fouille, un contrôle ou une radiographie sur les bagages du passager.",
                    "2": "Le transporteur ou l’agent agréé s’efforcera de fouiller, contrôler ou radiographier les bagages sous la présence du passager. Toutefois, si le passager n’est pas disponible, ses bagages pourront être fouillés, contrôlés et/ou radiographiés en son absence.",
                    "3": "Le transporteur peut refuser de transporter un passager ou ses bagages, si le passager s’oppose à une fouille, un contrôle ou une radiographie de sûreté et de sécurité.",
                    "4": "Le transporteur ne pourra pas être tenu pour responsable si lors d’une fouille, d’un contrôle, ou d’une radiographie, le passager, ou ses bagages, subissent un dommage, excepté si le dommage est directement et exclusivement le fait de la négligence ou de la faute du transporteur ou de l’agent agréé."
                  }
                },
                "6": {
                  "title": "3.10.6 Bagages enregistrés",
                  "text": {
                    "1": "Il est conseillé aux passagers d’indiquer sur leurs bagages de manière claire et lisible leur nom, prénom et adresse. Lors de l’enregistrement des bagages, le transporteur remet au passager une fiche d'identification pour chaque bagage.",
                    "2": "Pour des raisons de sûreté et de sécurité, ou pour des raisons opérationnelles, le transporteur peut décider de transporter les bagages enregistrés par un même passager dans des vols différents. Dans ce cas, c’est au transporteur de livrer au passager les bagages ayant été transportés sur un autre vol, à moins que le droit en vigueur exige la présence du passager lors des contrôles douaniers."
                  }
                },
                "7": {
                  "title": "3.10.7 Bagages à main",
                  "text": {
                    "1": "Les dimensions et le poids maximum des bagages à main est déterminé discrétionnairement par le transporteur. Pour rappel, les bagages doivent pouvoir tenir sous le siège devant le passager ou entrer dans un compartiment à bagage de la cabine.",
                    "2": "Si le bagage à main ne respecte pas les conditions fixées par le transporteur (poids, dimensions, et autre), alors il sera considéré comme un bagage en soute. Le passager devra alors le faire enregistrer.",
                    "3": "Si un bagage excède les dimensions et le poids maximum fixés par le transporteur pour les bagages à main, mais qu’il ne remplit pas les conditions requises pour être transporté en tant que bagage enregistré, le transporteur peut autoriser à titre exceptionnel le passager à le mettre dans la cabine de l’aéronef si, cumulativement:",
                    "4": "Le passager a informé le transporteur avant de s’enregistrer, qu’il souhaite que son bagage soit rangé dans la cabine de l’aéronef;",
                    "5": "Le transporteur a autorisé, avant l’enregistrement, que le bagage soit rangé dans la cabine de l'aéronef;",
                    "6": "Le passager s’est acquitté des frais supplémentaires applicables pour ce service, conformément aux tarifs en vigueur le jour de l’enregistrement."
                  }
                },
                "8": {
                  "title": "3.10.8 Collecte et livraison des bagages enregistrés transportés en soute",
                  "text": {
                    "1": "Le passager est tenu de récupérer ses bagages enregistrés dès que le transporteur les met à sa disposition. Si le passager tarde à le faire, le transporteur est en droit de lui facturer des frais de garde. Le passager a trois mois à compter de la date de remise des bagages pour les récupérer. Ce délai dépassé, le transporteur pourra les détruire sans que le passager ne puisse l’en tenir pour responsable.",
                    "2": "Seul le passager détenant la fiche d'identification de bagage et le bulletin de bagages (si celui-ci a été émis) est autorisé à réclamer le bagage enregistré.",
                    "3": "Si toutefois la personne qui réclame un bagage enregistré est dans l’incapacité de présenter la fiche d'identification de bagage, alors que celle-ci a été émise lors de l’enregistrement, le transporteur peut lui remettre le bagage à condition que la personne soit en mesure de prouver que le bagage lui appartient."
                  }
                },
                "9": {
                  "title": "3.10.9 Animaux",
                  "text": "Le transport des animaux est admis par certaines compagnies. Ce service est soumis à l’acceptation et aux conditions du transporteur."
                }
              }
            },
            "11": {
              "title": "3.11 Tarifs spéciaux",
              "text": {
                "1": "Certaines compagnies aériennes proposent des tarifs spéciaux pour les enfants de moins de 2 ans, les enfants et les seniors. Ces offres dépendent de la compagnie aérienne et du vol concernés, ainsi que de la disponibilité des places, et de l'âge des voyageurs.",
                "2": "La réduction relative au tarif enfant peut varier en fonction du tarif adulte appliqué par la compagnie aérienne pour le vol concerné. Il arrive donc parfois que le tarif enfant soit le même que le tarif adulte renseigné sur le site."
              }
            }
          }
        },
        "4": {
          "title": "Article 4. Conditions financières et modes de paiement",
          "text": {
            "1": "Les prix des prestations renseignées sur le site sont indiqués en euros, et ne comprennent pas les éventuelles taxes locales d’entrée ou de sortie imposées par certains pays, excepté si les Conditions spécifiques comprennent des mentions particulières contraires.",
            "2": "Le règlement du total du prix des prestations réservées sur le site ou par téléphone s'effectue auprès de l’AISC qui a son tour règle Amplitudes selon les conditions contractuelles.",
            "3": "Le prix des prestations est celui mentionné sur le site, sauf cas d'erreur manifeste. Les prix peuvent être modifiés à tout moment, mais ces changements n’auront pas d’incidence sur les réservations déjà acceptées, sauf dans les cas indiqués dans les présentes Conditions de vente. Amplitudes applique des frais de réservation et de mise en remboursement des prestations aériennes. L'utilisateur sera informé de tous les frais applicables lors de la réservation. Amplitudes s’efforce d’être vigilant, mais il peut arriver que le prix de certaines prestations mentionné sur le site soit erroné. Amplitudes se réserve expressément le droit de corriger ces erreurs sur le site, et de s’occuper des réservations réalisées sous un prix erroné. Amplitudes offrira à l’utilisateur, sous réserve de disponibilité, la possibilité de conserver sa réservation au prix corrigé, ou annulera la réservation sans aucune pénalité. Amplitudes n'a aucune obligation de fournir des prestations à un prix erroné qui serait plus bas à un utilisateur, et ce, même si l'utilisateur a reçu la confirmation de sa réservation.",
            "4": "Les coûts et les frais de service correspondent aux coûts liés aux prestations et qui sont supportés par les partenaires, notamment les taxes indirectes (TVA ou autres taxes similaires) et les autres frais nécessaires pour la gestion des réservations.",
            "5": "Hormis les cas mentionnés dans les présentes Conditions de vente concernant les taxes sur les montants retenus pour la fourniture de nos services, Amplitudes certifie ne pas collecter de taxes pour les reverser aux autorités fiscales compétentes."
          }
        },
        "5": {
          "title": "Article 5. Service utilisateurs et réclamations",
          "section": {
            "1": {
              "title": "5.1 Service utilisateurs",
              "text": {
                "1": "Conformément à la politique de confidentialité des données personnelles collectées et à la RGPD, l'utilisateur dispose à tout moment, d'un droit d'accès, de modification, de rectification et de suppression des données qui le concernent. L’utilisateur peut faire valoir ces droits en envoyant une requête par courrier électronique à l'adresse suivante: ",
                "2": "dpo@amplitudes.com",
                "3": ", sous réserve de justifier son identité."
              }
            },
            "2": {
              "title": "5.2 Service réclamations",
              "text": {
                "1": "Toute réclamation ou demande d’informations doit être adressé à Amplitudes, dans les 30 jours suivants la fin du séjour, à l’adresse électronique: ",
                "2": "airbus@amplitudes.com",
                "3": "Amplitudes ne prendra en compte les réclamations que lorsque les difficultés dont elles font l’objet lui auront été préalablement signalées, ou si lors du voyage il y a eu une requête auprès du partenaire concerné pour tenter de limiter le préjudice subi par l’utilisateur. Toutefois, en fonction des circonstances, des exceptions pourront éventuellement être admises.",
                "4": "Les bagages, les vêtements, et autres objets personnels sont placés sous la surveillance de l’utilisateur. Aucune réclamation ne sera donc acceptée en cas de perte, avarie ou vol, sauf s’il est prouvé qu’il y a eu une faute de la part d’Amplitudes ou d’un de ses partenaires. Les bagages enregistrés auprès d'une compagnie aérienne ne sont assurés que pendant la durée du transport."
              }
            }
          }
        },
        "6": {
          "title": "Article 6. Responsabilités et garanties",
          "text": "Sauf en cas de dispositions légales contraires, Amplitudes ne pourra pas être tenu pour responsable conformément aux contrats de prestations que l'utilisateur aura conclu avec un ou plusieurs partenaire(s) et notamment lorsque le dommage est imputable à l'utilisateur, ou au fait, imprévisible et insurmontable, d'un tiers étranger à la fourniture des prestations prévues au contrat, ou à un cas de force majeure."
        },
        "7": {
          "title": "Article 7. Protection des données personnelles",
          "text": "La Convention de collaboration signée entre l’AISC et Amplitudes fixe les conditions d’utilisation des données personnelles auxquelles se sont engagées les deux parties. Elles sont disponibles auprès de l’AISC."
        },
        "8": {
          "title": "Article 8. Droit applicable",
          "text": {
            "1": "Les présentes Conditions générales de vente sont soumises au droit français. Tout litige relatif à leur interprétation et/ou à leur exécution sera pris en charge par les Tribunaux de Toulouse.",
            "2": "En cas de différend entre Amplitudes et l’utilisateur, ce dernier peut recourir à une procédure de médiation conventionnelle, ou s’il le souhaite à un autre mode alternatif de règlement des litiges, conformément à ce qui est défini dans le droit français, notamment par les articles 1528 et suivants du Code de procédure civile.",
            "3": "Amplitudes dépend du médiateur de la consommation tourisme et voyage (",
            "3-link": "http://www.mtv.travel/",
            "4": "). Dans le cas où après avoir saisi par écrit le service réclamation d’Amplitudes, l’utilisateur n’obtient aucune réponse qui le satisfasse dans un délai de 60 jours, il est en droit de faire appel au médiateur tourisme et voyage, dans les conditions et modalités de saisie prévues sur le site du médiateur. Il est possible de contacter le médiateur tourisme et voyage à l’adresse suivante: ",
            "5": "MTV Médiation Tourisme Voyage",
            "6": "BP 80 303",
            "7": "75 823 Paris Cedex 17",
            "8": "Vous pouvez également soumettre vos litiges via la plateforme de règlement en ligne des litiges de la Commission européenne disponible à l'adresse suivante: ",
            "8-link": "http://ec.europa.eu/odr"
          }
        },
        "9": {
          "title": "Article 9. Formalités d’assurances",
          "text": {
            "1": "L’AISC ayant elle-même souscrit le 1er Septembre 2004 un contrat auprès de la compagnie Axa sous le numéro 0800594*04, couvrant l’ensemble de ses ouvrant-droits lorsqu’ils partent dans le cadre d’un voyage individuel ou de groupe par son intermédiaire.",
            "2": "L’AISC demande expressément à Amplitudes de ne pas assurer ses ouvrant-droit dans le cadre des garanties annulation, bagages, assistance rapatriement, médicale et juridique.",
            "3": "Par accord mutuel, AMPLITUDES s'abstiendra de proposer l'assurance annulation facultative que l’AISC proposera aux ouvrant-droit lors de la confirmation.",
            "4": "En cas d'annulation, l’ouvrant-droit s'adressera directement à l’AISC et non à AMPLITUDES."
          },
          "section": {
            "1": {
              "title": "9.1 Responsabilité",
              "text": "Amplitudes, de même que son assureur Mutuaide Assistance (8-14 avenue des Frères Lumière, 94368 Bry-sur-Marne CEDEX), ne sauraient être engagés pour des manquements ou contretemps à l’exécution de ses obligations qui résulteraient de cas de force majeure, ou d’événements tels que la guerre civile ou étrangère, les émeutes ou mouvements populaires, le lock-out, les grèves , les attentats, les actes de terrorisme, les pirateries, les tempêtes et ouragans, les tremblements de terre, les cyclones, les éruptions volcaniques ou autres cataclysmes (faisant l’objet de la procédure visée par la loi N° 82.600 du 13 juillet 1982), la désintégration du noyau atomique, l’explosion d’engins et les effets nucléaires radioactifs, les épidémies, les effets de la pollution et catastrophes naturelles, les effets de radiation ou tout autre cas fortuit ou de force majeure, ainsi que leurs conséquences."
            },
            "2": {
              "title": "9.2 Responsabilité civile professionnelle",
              "text": {
                "1": "Amplitudes a souscrit auprès de AXA Assurances (21 place Dupuy - 31000 Toulouse) une assurance de Responsabilité civile professionnelle (contrat n° 0539538504).",
                "2": "Cette assurance est engagée lorsque les conséquences de la Responsabilité civile professionnelle incombent à l’assuré en raison de dommage(s) corporel(s), matériel(s) et immatériel(s) causés à ses clients ou à des tiers à la suite de fautes, erreurs ou négligences commises durant l’exercice de sa fonction."
              }
            }
          }
        },
        "10": {
          "title": "Article 10. Dispositions finales",
          "text": {
            "1": "Le fait qu'Amplitudes ne se prévale pas, à un moment donné, d'une des dispositions des Conditions générales de vente ne pourra pas être interprété comme une renonciation par elle-même à se prévaloir ultérieurement de l'une de ces dispositions.",
            "2": "Dans le cas où l'une des dispositions des Conditions générales de vente serait déclarée nulle ou sans effet, elle serait réputée non écrite, sans que cela n'affecte la validité des autres dispositions, excepté si la disposition déclarée nulle ou sans effet s’avère essentielle et déterminante.",
            "3": "Tout cas de force majeure suspend les obligations des présentes affectées par le cas de force majeure et libère de toute responsabilité la partie qui aurait dû exécuter l'obligation."
          }
        }
      }
    },
    "partners-conditions": {
      "title": "Conditions spécifiques des partenaires",
      "text": "Sur cette page vous trouverez les liens donnant accès aux conditions de transport des compagnies aériennes, ainsi qu’à leur politique en matière de bagages. Vous y trouverez également la procédure à suivre pour l’enregistrement en ligne et des indications concernant vos réservations.",
      "online-registration": {
        "title": "Enregistrement en ligne",
        "text": {
          "1": "Pour gagner du temps à l’aéroport, il est possible d’effectuer votre enregistrement en ligne sur le site de la compagnie à bord de laquelle vous allez voyager. Il est généralement possible de s’enregistrer à partir de 36 heures avant votre heure de départ. Ceci varie selon les compagnies. Après vous être enregistré en ligne, vous pourrez imprimer vos cartes d'embarquement ou les sauvegarder sur votre téléphone mobile afin de pouvoir les présenter lors de l’embarquement.",
          "2": "Pour procéder à un enregistrement en ligne, cliquez sur le lien ci-dessous de la compagnie aérienne auprès de laquelle vous avez réservé vos vols. Ce lien vous mènera directement à la page d’enregistrement en ligne.",
          "3": "Nous précisons que cette liste n’est pas exhaustive. Toutefois, il est possible que la compagnie aérienne avec laquelle vous voyagez ne propose pas ce service, et par conséquent elle ne sera pas répertoriée sur cette liste. Auquel cas vous devrez vous enregistrer à l'aéroport."
        }
      },
      "baggage": {
        "title": "Bagages",
        "text": "Les franchise et les politiques commerciales concernant les bagages varient en fonction des compagnies aériennes. Il est fortement recommandé de se renseigner en consultant les Conditions de transport des compagnies aériennes à bord desquelles vous voyagez."
      },
      "low-cost-carriers": {
        "title": "Transporteurs à bas coût ou low-cost",
        "text": {
          "1": "La plupart des compagnies aériennes dites à bas coût, ou low-cost, n’incluent pas l’enregistrement des bagages dans leurs tarifs de base.",
          "2": "Ainsi si vous avez choisi un tarif sans bagage lors de votre réservation et que finalement vous allez voyager avec un bagage nous vous conseillons d’enregistrer votre bagage en ligne avant votre départ. Les frais qui vous seront alors demandés seront en général moindres que ceux qui vous seront facturés à l’aéroport le jour de votre départ.",
          "3": "Pour effectuer un enregistrement de bagage, vous avez besoin de votre numéro de réservation, de votre adresse électronique et de votre carte de crédit si vous avez initialement réservé un tarif sans bagages."
        }
      },
      "regular-carriers": {
        "title": "Transporteurs réguliers",
        "text": {
          "1": "Les compagnies aériennes qui proposent un service complet sont appelées transporteurs réguliers. Selon que le passager voyage en classe Économie ou Affaires, les transporteurs réguliers n’appliquent pas la même franchise bagage.",
          "2": "Pour les passagers qui voyagent en classe Économie la franchise est généralement limitée à un poids maximum de 23 kg. En revanche pour les personnes voyageant en classe Affaires il est généralement autorisé d’avoir un bagage de 32 kg maximum sans frais supplémentaires.",
          "3": "Attention, de nombreuses compagnies régulières proposent des tarifs sans bagage en particulier sur les vols court courrier.",
          "4": "Nous vous conseillons dans tous les cas de consulter les Conditions de transport de la compagnie aérienne à bord de laquelle vous allez voyager pour connaitre sa politique globale et en particulier en matière de transport de bagages."
        }
      },
      "mandatory-travel-documents": {
        "title": "Documents de voyage obligatoires",
        "text": {
          "1": "Les formalités à accomplir et les documents de voyage nécessaires sont l’objet de changements fréquents de la part des autorités nationales. Nous vous conseillons très fortement avant d’entreprendre votre voyage de consulter le site du Ministère des Affaires Etrangères en suivant ce lien: ",
          "1-link": "https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/",
          "2": "Dans le cas d’une vente de vol seul, Amplitudes ne saurait être tenu pour responsable d’un refus d’embarquement du fait d’un défaut de présentation d’un document ou de réalisation d’une formalité préalable au départ."
        }
      }
    }
  },
  "en": {
    "title": "Conditions Générales de Ventes",
    "tac-flight": {
      "title": "CONDITIONS GÉNÉRALES DE VENTE VOLS SECS",
      "contact-information": {
        "1": "airbus-staffcouncil.amplitudes.com est un service du groupe Amplitudes",
        "2": "AMPLITUDES, 20 rue du Rempart Saint-Etienne - 31 000 Toulouse – Vigma SAS au capital de 550 000 euros – Siret 380 775 122 00035 RCS B 380 775 122 Code APE 7911 Z."
      },
      "article": {
        "1": {
          "title": "Article 1. Définitions et champs d'application",
          "section": {
            "1": {
              "title": "1.1 Définitions",
              "text": {
                "1": "Les définitions citées ci-dessous gardent la même signification au singulier et au pluriel.",
                "2": "Certaines sont issues du Règlement Européen n° 261/2004.",
                "3": "PARTENAIRE",
                "4": "Désigne tous les fournisseurs qui livrent une prestation.",
                "5": "PRESTATION",
                "6": "Désigne les prestations de services proposées sur le site: airbus-staffcouncil.amplitudes.com",
                "7": "SITE",
                "8": "Désigne le site internet: airbus-staffcouncil.amplitudes.com",
                "9": "UTILISATEUR",
                "10": "Désigne toute personne qui consulte le site, réserve et/ou achète une ou plusieurs prestations.",
                "11": "TRANSPORTEUR AÉRIEN",
                "12": "Désigne les compagnies opérant des services de transport aérien, et possédant une licence d'exploitation en cours de validité.",
                "13": "RÉSERVATION",
                "14": "Désigne la prise en compte et la confirmation par un transporteur aérien, ou un agent agréé, d’une demande de transport effectuée par un utilisateur sur le site internet.",
                "15": "TARIF/TARIFAIRE",
                "16": "Désigne les conditions tarifaires que le transporteur aérien a publié et déposé, le cas échéant, auprès des autorités compétentes.",
                "17": "BILLET",
                "18": "Désigne un document en cours de validité, matériel ou immatériel, donnant droit au client à un transport, et qui a été délivré ou autorisé par le transporteur aérien ou son agent agréé.",
                "19": "PASSAGER",
                "20": "Désigne la personne transportée, ou devant l’être, et qui s’est préalablement acquittée d’un billet en cours de validité; ou dans le cas d’un remboursement, la personne ayant payé le billet.",
                "21": "BÉNÉFICIAIRE/ASSURÉ",
                "22": "Désigne une personne, ou un groupe de personne, ayant souscrit au contrat d’assurance proposé par Amplitudes."
              }
            },
            "2": {
              "title": "1.2 Champ d'application",
              "text": {
                "1": "Les présentes Conditions générales de vente régissent l’offre et la fourniture des prestations proposées sur le site airbus-staffcouncil.amplitudes.com.",
                "2": "Avant de pouvoir procéder à un achat, l’utilisateur doit avoir pris connaissance dans leur intégralité des Conditions générales de vente et de la Politique de confidentialité des données personnelles collectées, et les avoir acceptées en cochant la case ou en cliquant sur les liens prévus à cet effet. Le processus de réservation ne pourra pas se faire sans cette acceptation. L’utilisateur doit donc finaliser le processus de réservation sur le site en prenant connaissance et en acceptant les présentes Conditions générales de vente et la Politique de confidentialité des données collectées.",
                "3": "Les Conditions spécifiques des partenaires s’appliquent également à l’offre et à la fourniture des prestations selon les mêmes modalités que les Conditions générales de vente. Il incombe à l’utilisateur de prendre connaissance des Conditions spécifiques du partenaire concerné et des Conditions spécifiques des prestations en les consultant sur le lien: ",
                "3-href": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "4": "Amplitudes se réserve le droit de modifier à tout moment et sans préavis les présentes Conditions générales de vente. Ces modifications ne concerneront pas les réservations de prestations réalisées antérieurement. Il est donc important que lors de son achat, l’utilisateur s’assure des dispositions en vigueur en prenant connaissance des Conditions générales de vente avant de les accepter."
              }
            }
          }
        },
        "2": {
          "title": "Article 2. Conditions de réservation",
          "section": {
            "1": {
              "title": "2.1 Utilisation du site",
              "text": {
                "1": "Le site permet à l’utilisateur de rechercher des prestations de transport aérien, d’effectuer des réservations, et de conclure une transaction avec les partenaires. Nous rappelons ici que les mineurs ne sont pas autorisés à effectuer une quelconque réservation sur le site d’airbus-staffcouncil.amplitudes.com. De plus l’utilisateur doit être juridiquement capable d’utiliser le site.",
                "2": "L’utilisateur est responsable des démarches financières qu’il entreprend sur le site airbus-staffcouncil.amplitudes.com. Il est donc tenu de veiller à l’utilisation qui est faite de son nom d’utilisateur et de son mot de passe. En cas de fraude, il appartient à l’utilisateur de rapporter la preuve du délit. Il doit également garantir la véracité et l'exactitude des informations le concernant renseignées sur le site.",
                "3": "En cas d’utilisation frauduleuse du site, ou qui ne respecterait pas les présentes Conditions générales de vente, Amplitudes se réserve le droit de refuser à un utilisateur l’accès aux prestations proposées par Amplitudes, et/ou par ses partenaires, ainsi qu’aux autres fonctionnalités du site."
              }
            },
            "2": {
              "title": "2.2 – Modalités d’accès à un transport aérien",
              "sub-section": {
                "1": {
                  "title": "2.2.1. Responsabilités et obligations du passager",
                  "sub-sub-section": {
                    "1": {
                      "title": "2.2.1.1. Formalités administratives",
                      "text": {
                        "1": "L’utilisateur peut trouver toutes les informations concernant les formalités administratives nécessaires à l’exécution de son voyage sur le site: ",
                        "1-link": "http://www.diplomatie.gouv.fr/fr/",
                        "2": "Il est de la responsabilité de l’utilisateur d’en prendre connaissance. Lors du consentement aux présentes Conditions générales de vente, l’utilisateur reconnait s’être informé sur les formalités administratives à suivre pour pouvoir voyager.",
                        "3": "Le passager est tenu de s’informer sur les conditions d’entrée sur le territoire du pays dans lequel il se rend et de s’y conformer. Il en va de même pour les pays qu’il quitte, qu’il traverse par avion, ou dans lequel il se trouve en qualité de passager en transit. Il doit également connaître l’ensemble des lois, règlements ou actes qui régissent le pays, et s’y conformer.",
                        "4": "Avant d’entreprendre un voyage vers des destinations internationales, Amplitudes conseille à ses utilisateurs de consulter les interdictions de voyager, alertes, annonces et conseils publiés par les gouvernements concernés. Vous trouverez des conseils aux voyageurs en fonction des pays sur le site internet de France Diplomatie: ",
                        "4-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays/",
                        "5": "En proposant des produits de voyage dans certaines destinations internationales, Amplitudes ne garantit pas que le voyage dans ces zones soit recommandé ou ne présente aucun risque.",
                        "6": "Lors de son enregistrement et de son embarquement, le passager doit être en mesure de présenter au transporteur les documents exigés par les conditions d’entrée du territoire (passeport, visa, certificat sanitaire et autres). Ceux-ci doivent impérativement être en règle et valides. En fonction de la loi et des règlementations en vigueur, les douaniers et autres agents agréés peuvent éventuellement demander au passager d’être présent lors de l’inspection de ses bagages.",
                        "7": "Passeport",
                        "8": "Il est conseillé aux ressortissants français de s’informer sur les exigences applicables concernant les passeports en consultant le site de France Diplomatie: ",
                        "8-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/infos-pratiques-20973/preparer-son-depart-20975/formalites-administratives/article/formalites-administratives",
                        "9": "Rappelons que dans certains pays la règlementation impose que le passeport du passager ait une validité supérieure à 6 mois à partir de la date d'entrée sur le territoire. Par conséquence, Amplitudes recommande donc aux utilisateurs de vérifier la date de validité de leur passeport, et de prendre connaissance des exigences applicables du pays de destination, avant de finaliser leur projet de voyage.",
                        "10": "Le nom du passeport doit impérativement correspondre au nom indiqué sur le billet, autrement l’utilisateur ne pourra pas voyager avec les transporteurs aériens, et il ne pourra pas non plus faire fonctionner l’éventuelle assurance à laquelle il aurait souscrit. Toutefois, si un passager change de nom de famille pour une quelconque raison après la réservation, mais avant le départ, il est prié d’en informer au plus vite Amplitudes afin de faire le nécessaire pour que le voyage se déroule sans problème.",
                        "11": "Rappelons également que les enfants doivent être impérativement en possession de papiers d'identité en cours de validité et à leur nom, et cela quel que soit leur âge.",
                        "12": "Visa",
                        "13": "Pour toute information concernant les visas, il est conseillé aux utilisateurs de contacter l'ambassade du pays qu'ils envisagent de visiter. L’obtention d’un visa peut prendre un certain temps, nous recommandons aux utilisateurs de faire les démarches nécessaires suffisamment à l’avance.",
                        "14": "Il arrive que les conditions d'obtention d'un visa changent, c’est pourquoi il est conseillé de vérifier que les informations obtenues soient d’actualité avant de procéder à la réservation, et également avant votre départ. Amplitudes ne pourra être tenu pour responsable si le passager se voit refuser l’entrée dans un avion ou un pays, en raison de son incapacité à présenter un passeport ou visa adéquat, ou tout autre document de voyage exigé par la compagnie aérienne, les autorités ou la règlementation du pays. Cela inclut tous les transits et les arrêts effectués par l'avion, même si le passager ne quitte pas l'avion ou l'aéroport.",
                        "15": "ESTA",
                        "16": "Pour entrer aux Etats-Unis, ou pour y effectuer un transit, avec le Programme d’exemption de visa, le voyageur doit demander à voyager sous le système électronique d'autorisation de voyage (Electronic System for Travel Authorization ou ESTA). Pensez à effectuer votre demande d'ESTA suffisamment à l’avance. Il est conseillé de faire les démarches pour une demande d’ESTA au moins 72 heures avant le départ. Pour plus d'information, consultez le site internet du Département américain de la sécurité intérieure: ",
                        "16-link": "https://esta.cbp.dhs.gov/esta"
                      }
                    },
                    "2": {
                      "title": "2.2.1.2 Formalités sanitaires",
                      "text": {
                        "1": "Il est de la responsabilité de l’utilisateur de prendre connaissance des formalités sanitaires nécessaires à l’exécution de son voyage en les consultant sur le site ",
                        "1-link": "http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/",
                        "1-end": "Lors du consentement aux présentes Conditions générales de vente, l’utilisateur reconnait s’être informé sur les formalités sanitaires à suivre pour pouvoir voyager.",
                        "2": "Vaccination et conseils médicaux",
                        "3": "Il peut être demandé aux voyageurs pour certaines destinations de faire des vaccins. Toutefois les recommandations peuvent changer. C’est pourquoi il est conseillé de consulter un médecin avant le départ pour un voyage afin de s’informer sur les recommandations en vigueur. Il est de la responsabilité du voyageur de s’assurer qu’il respecte toutes les conditions d’entrée sur le territoire liées à la santé. Il doit donc avoir obtenu toutes les inoculations obligatoires ou recommandées, veiller à prendre les médicaments requis, et suivre les instructions du médecin. Vous pouvez trouver des conseils médicaux sur le site: ",
                        "3-link": "http://www.pasteur.fr/fr/map",
                        "4": "Règlementation sur la désinsectisation",
                        "5": "Certains pays se réservent le droit de désinsectiser l’avion s’ils considèrent qu’il y a une menace pour la santé publique, l’agriculture ou l’environnement. L'Organisation mondiale de la santé et l'Organisation internationale de l'aviation civile ont approuvé les procédures de désinsectisation suivantes:",
                        "6": "Vaporiser la cabine de l'avion avec un aérosol insecticide pendant que les passagers sont à bord de l'avion",
                        "7": "Traiter les surfaces intérieures de l'avion avec un insecticide résiduel lorsqu'aucun passager n'est à bord de l'avion",
                        "8": "Pour plus d'informations, veuillez consulter le site de la DGAC (Direction générale de l'aviation civile): ",
                        "8-link": "http://www.developpement-durable.gouv.fr/-Passagers-aeriens-s-informer-pour-.html",
                        "9": ", ou le site du Ministère de la santé: ",
                        "9-link": "http://www.sante.gouv.fr/controle-sanitaire-dans-les-aeroports.html"
                      }
                    }
                  }
                },
                "2": {
                  "title": "2.2.2 Limites de responsabilités et obligations d’Amplitudes et de ses partenaires",
                  "text": {
                    "1": "Ni Amplitudes, ni le transporteur, ne pourront être tenus pour responsable si le passager:",
                    "2": "N’est pas en mesure de présenter les documents de voyage exigés par la règlementation (passeports, visas, certificats de bonne santé et autres);",
                    "3": "Est en possession de documents de voyage (passeports, visas ou certificats de bonne santé ou autres documents) invalides ou périmés;",
                    "4": "N’a pas respecté les lois, règlementations et actes en vigueur;",
                    "5": "N’était pas présent lors du contrôle douanier de ses bagages et qu’un dommage a été subi au cours de l’inspection."
                  }
                },
                "3": {
                  "title": "2.2.3 Refus à l’entrée d’un territoire",
                  "text": {
                    "1": "Ni Amplitudes, ni le transporteur ne pourront être tenu pour responsables si le passager se voit refuser par les autorités et le gouvernement l’entrée sur le territoire. De ce fait, il incombera au passager d’assumer les conséquences directes et indirectes de ce refus. Tous les frais qui en résulteraient seront donc à la charge du passager, ce qui comprend:",
                    "2": "Toute amende, pénalité ou charge qui serait réclamée au transporteur par le gouvernement en raison de ce refus;",
                    "3": "Tous frais de détention qui seraient facturés au transporteur;",
                    "4": "Le prix du billet de transport qui a servi à ramener le passager chez lui;",
                    "5": "Tout autre coût que le transporteur serait amené à assumer, ou dont il conviendrait avec les autorités et/ou le gouvernement du pays de payer.",
                    "6": "Dans le cas où l’entrée du territoire aurait été refusé à un passager, ni Amplitudes, ni le transporteur ne seront tenus de lui rembourser le billet de transport vers le pays de destination."
                  }
                },
                "4": {
                  "title": "2.2.4 Remboursement des amendes, frais de détention et autres charges",
                  "text": {
                    "1": "S’il ne respecte pas les lois, les règlements ou les autres obligations en vigueur en ce qui concerne le voyage ou l’entrée sur le territoire du pays de destination, le passager est tenu de s’acquitter de la totalité des amendes, pénalités, frais, ou coûts payés par le transporteur en raison du non-respect de ces lois, règlements et obligations. Cela est également valable si le passager ne présente pas les documents de voyage adéquats et nécessaires requis par le pays."
                  }
                },
                "5": {
                  "title": "2.2.5 Inspections des douanes, de la police ou d’autres autorités publiques, et contrôle de sécurité",
                  "text": {
                    "1": "Lorsque les lois, règlementations ou actes l’exigent, le service des douanes, ou d’autres fonctionnaires ou agents publics compétents, peuvent demander au passager d’être présent lors de l’inspection de ses bagages. Le transporteur ne pourra pas être tenu pour responsable des dommages directs ou indirects subis par le passager et/ou ses bagages lors d'une inspection, ni du fait de l’absence du passager lors de celle-ci.",
                    "2": "En acceptant les présentes Conditions générales de vente, le passager autorise, pour des raisons de sécurité et de sûreté, les fonctionnaires, les agents publics, les agents des autorités aéroportuaires ou le transporteur et ses agents agréés, à réaliser des contrôles de sécurité sur lui ou ses bagages, et s’engage à ne pas s’y opposer."
                  }
                }
              }
            },
            "3": {
              "title": "2.3 Passation et annulation de réservations",
              "text": {
                "1": "Amplitudes transmettra à l’utilisateur la confirmation de réservation dans un délai minimum de 1 jour ouvré après la date de réservation. La confirmation de réservation se compose de l’identification de la prestation réservée (ou des prestations s’il y en a plusieurs) et le prix.",
                "2": "Toutes les conditions d'annulation, de rectification des réservations ou de remboursement sont disponibles sur ",
                "2-link": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "3": "Toute demande d’annulation ou de modification doit être transmise à Amplitudes par courrier électronique à l’adresse: ",
                "3-link": "airbus@amplitudes.com",
                "4": "Amplitudes prendra en charge toutes les requêtes au nom des partenaires concernés. L’utilisateur ne dispose pas d’un droit d’annulation automatique. Les Conditions spécifiques des partenaires sont accessibles sur leurs sites respectifs que l’utilisateur peut aller les consulter avant de réserver. Toute annulation totale ou partielle d’une réservation est soumise aux Conditions spécifiques du partenaire concerné.",
                "5": "Par ailleurs, en cas d'annulation totale ou partielle d’une réservation du fait de l'utilisateur, du prestataire ou d’une décision administrative en France ou dans un des pays de destination ou de transit, les frais d’émission initiaux des titres de transport ne sont remboursables en aucun cas.",
                "6": "D’autre part, des frais de mise en remboursement et d’établissement d’un avoir de 10€ par billet seront déduits des montants remboursés par le prestataire.",
                "7": "Il peut lui être demandé par le partenaire concerné de régler certains frais. Si l’annulation concerne plusieurs personnes, tout frais d'annulation applicable sera assigné respectivement à chaque personne concernée. Dans certains cas, la compensation à verser aux partenaires pour l’annulation pourra être égale au montant total du voyage réservé, et l’utilisateur ne pourra pas demander un remboursement à ce titre.",
                "8": "Aucun remboursement ne pourra être réclamé si l’utilisateur ne se présente pas au départ du voyage.",
                "9": "Lorsqu’Amplitudes modifie une réservation pour l’utilisateur, il arrive qu’il doive annuler la réservation initiale. Dans ce cas des frais d’annulation de 10€ par billet seront appliqués de même que des frais d’émissions pour les nouveaux billets. Toute annulation peut également entraîner un paiement de compensation et/ou des frais établis par les Conditions spécifiques du partenaire. Ces frais peuvent être égaux à la valeur totale du voyage réservé. L’utilisateur est alors tenu de payer les frais de sa nouvelle réservation.",
                "10": "À défaut des dispositions particulières mentionnées préalablement sur le site, toute modification ou toute annulation émanant de l'utilisateur (à l’exception des cas de force majeure et sauf accord favorable du partenaire concerné) entraîne la perception d'une indemnité d'un montant équivalent à la totalité du prix de la prestation, sans préjudice de l’application de frais de dossier dans le cas d’une annulation ou une modification dans les conditions définies ci-dessus. De ce fait, le remboursement du billet d'avion ne pourra être accordé qu'avec l'accord préalable du partenaire concerné.",
                "11": "Lorsqu’un billet a été réémis suite à une annulation ou modification émanant de l’utilisateur, le prix du nouveau billet peut s’avérer être plus élevé que celui du billet initial. La différence de prix sera donc à régler par l’utilisateur. Dans ce cas Amplitudes facturera à l’utilisateur des frais de mise en remboursement de 10€ par billet ainsi que des frais d’émission selon le barème contractuel de l’AISC, conformément aux stipulations du présent article.",
                "12": "En cas de remboursement de l'utilisateur, les sommes préalablement versées seront recréditées sur le compte de l’AISC.",
                "13": "Si le titre de transport est invalide, ou s’il n’a pas permis au passager de bénéficier du transport aérien, ce dernier peut demander un remboursement de la totalité, ou d’une partie, des taxes aériennes et redevances passagères incluses dans le prix du billet. Le remboursement se fera dans la limite des taxes aéroportuaires et redevances passagères remboursées par le partenaire, des éventuels frais de mise en remboursement prélevés par celui-ci et des frais de mise en remboursement Amplitudes de 10€ par billet.",
                "14": "L’utilisateur recevra le remboursement des taxes et redevances au plus tard 30 jours après la date de réception de la demande. Pour nous faire parvenir sa demande de remboursement, il doit l’envoyer par courrier électronique à l’adresse: ",
                "14-link": "airbus@amplitudes.com",
                "15": "Si l’utilisateur fait parvenir sa demande de remboursement par un autre moyen que celui spécifié ci-dessus, il lui sera facturé des frais de traitement dans la limite de 20% de la somme remboursée.",
                "16": "L’utilisateur ne pourra obtenir le remboursement qu’une seule fois. Tout remboursement est soumis aux Conditions spécifiques du partenaire concerné, et tient compte de la limite des sommes autorisées par ledit partenaire."
              }
            },
            "4": {
              "title": "2.4 Convocation et retrait des documents de voyage",
              "text": {
                "1": "Tous les documents de voyage sont envoyés par messagerie électronique à l'adresse mentionnée par l'utilisateur lors de sa réservation sur le site.",
                "2": "Toutefois si Amplitudes ne parvient pas à envoyer les documents de voyage à l’utilisateur en raison d’une erreur de ce dernier dans la saisie de ses coordonnées, ni Amplitudes ni le partenaire concerné ne pourront être tenu pour responsables."
              }
            },
            "5": {
              "title": "2.5 Preuve de la réservation",
              "text": "Il est entendu que les données conservées dans le système d'information d’Amplitudes et/ou de ses partenaires ont force probante en ce qui concerne les réservations, excepté dans le cas d’une erreur manifeste de la part d’Amplitudes ou des partenaires dont l'utilisateur rapporterait la preuve. Les données sur support informatique ou électronique constituent des preuves valables et en tant que telles, et sont recevables dans les mêmes conditions et avec la même force probante que tout autre document établi, reçu ou conservé par écrit."
            },
            "6": {
              "title": "2.6 Droit de rétractation",
              "text": {
                "1": "Compte tenu de l'article L.121-21-8° du Code de la consommation, et en accord avec le Code de la consommation en matière de vente à distance, les prestations proposées par Amplitudes, en son nom ou au nom de ses partenaires ne sont pas soumises à l'application du droit de rétractation prévu aux articles L121-21.",
                "2": "Par conséquence, toutes les prestations réservées sur le site d’Amplitudes sont soumises aux conditions d’annulation et de modification prévues dans les présentes Conditions générales de vente et/ou dans les Conditions spécifiques des partenaires en vigueur."
              }
            }
          }
        },
        "3": {
          "title": "Article 3. Le Transport Aérien",
          "text": {
            "1": "Les prestations de transport aérien sont proposées seules."
          },
          "section": {
            "1": {
              "title": "3.1 Conditions de voyages",
              "text": {
                "1": "Les conditions d'exécution des transports aériens sont régies par les Conditions spécifiques des compagnies aériennes ou des partenaires (notamment les conditions de transport et les conditions tarifaires). Selon les cas les Conditions spécifiques peuvent prévoir des restrictions sur les frais d’annulation ou de modification d'une réservation. Les Conditions Spécifiques des partenaires fournissant des prestations de transport aérien sur le site d’Amplitudes sont disponibles sur le site: ",
                "1-link": "https://airbus-staffcouncil.amplitudes.com/general_terms_and_conditions#partners-conditions",
                "2": "L’AISC paye directement Amplitudes pour les réservations de billets d'avion des utilisateurs, de ce fait Amplitudes agit en qualité de mandataire du partenaire fournissant les prestations de transport aérien pour les compagnies aériennes membres du Billing and Settlement Plan (autres que low cost). Autrement dit le contrat de l'utilisateur pour les prestations de transport aérien qu’il a commandé est signé entre l'utilisateur et le partenaire fournissant lesdites prestations."
              }
            },
            "2": {
              "title": "3.2 Conditions spécifiques des Compagnies aériennes",
              "text": {
                "1": "Tout transport aérien est soumis aux Conditions spécifiques de la compagnie aérienne concernée. Celles-ci permettent de mettre en place les conditions de responsabilité et les mesures mises en place pour les personnes en situation de handicap, à mobilité réduite ou à forte corpulence, les enfants, les femmes enceintes, le transport de bagage (notamment pour les objets et substances interdits en soute, la franchise bagage et le tarif des excédents bagage), les transports d’animaux et autres.",
                "2": "Pour toute question relative à ces Conditions spécifiques, l’utilisateur doit se reporter aux Conditions générales de transport disponibles sur les sites de chaque compagnie aérienne.",
                "3": "L’utilisateur est tenu de respecter les consignes des compagnies aériennes et des partenaires, notamment en ce qui concerne les délais de présentation pour l'enregistrement. Nous conseillons aux voyageurs de se présenter à l'enregistrement au moins trois heures avant le départ de l'avion pour les vols internationaux et au moins deux heures et demie à l'avance pour les vols intérieurs."
              }
            },
            "3": {
              "title": "3.3 Responsabilité des transporteurs aériens",
              "text": "Nous rappelons que la responsabilité des transporteurs aériens se trouve souvent limitée par le droit national ou international qui leur est applicable, ou par leurs propres Conditions spécifiques qui leurs sont également applicables de plein droit."
            },
            "4": {
              "title": "3.4 Règlementation sur l’identité du transporteur aérien",
              "text": {
                "1": "Il arrive parfois que l’utilisateur ait acheté un billet de transport sur une compagnie aérienne, mais qu’il voyage avec une autre. C'est le cas par exemple lorsque le premier transporteur (le transporteur contractuel, qui est responsable du voyage) a affrété un vol de la seconde compagnie (le transporteur de fait, qui assure le vol) ou conclu avec elle un accord de partage de code.",
                "2": "Le vendeur a le devoir d’informer par écrit l’utilisateur sur l'identité du transporteur contractuel et du (des) transporteur(s) de fait, avant et au moment de l'achat du billet, selon les articles R. 322-1 à R. 322-7 du code de l'aviation civile.",
                "3": "Si le vol affrété est non régulier, alors la liste peut contenir jusqu’à cinq transporteurs. Si le choix du (des) transporteur(s) est ensuite modifié, le vendeur est tenu d’en informer les voyageurs dès que possible, ou au plus tard avant l'enregistrement, ou avant les opérations d'embarquement dans le cas d’une correspondance sans enregistrement préalable. Un changement du choix de transporteur ne pourra pas être considéré comme un motif valable pour demander une annulation et un remboursement, sauf si le transporteur de fait se trouve sur la liste noire européenne selon l’article 3, rubrique 3.11."
              }
            },
            "5": {
              "title": "3.5 Identité des passagers",
              "text": {
                "1": "Le nom et le prénom qui ont été renseigné au moment de la réservation doivent correspondre strictement à ce qui est indiqué sur les papiers d’identité en cours de validité qui seront présentés lors de l’enregistrement et de l’embarquement.",
                "2": "Pour les trajets aériens comportant un survol de l’espace aérien américain, plus particulièrement pour les Etats-Unis, le Canada, le Mexique et Cuba, il y a certaines recommandations que l’utilisateur doit prendre en compte. Pour les documents administratifs nécessaires au voyage, les autorités américaines recommandent aux femmes mariées d’utiliser leur nom de jeune fille. Il doit être renseigné sur le billet d’avion et le formulaire ESTA, ainsi que sur les différentes formalités de sécurité obligatoires pour l’accès ou le transit aux Etats-Unis."
              }
            },
            "6": {
              "title": "3.6 Bébés, enfants et femmes enceintes",
              "text": {
                "1": "Les compagnies aériennes se réservent le droit de refuser l’accès au transport aux femmes enceintes s’ils considèrent qu’il y a un risque en raison du terme de grossesse. Toutes les informations concernant le transport des femmes enceintes se trouvent dans les Conditions spécifiques du partenaire. L’utilisateur est tenu d’en prendre connaissance si nécessaire et de les respecter.",
                "2": "Dans le cas d’un voyage avec un enfant ou un bébé, l’utilisateur est tenu de prendre connaissance des Conditions spécifiques du partenaire concernant le transport des enfants et des bébés, et de les respecter. Les enfants de moins de 2 ans ne disposent pas de siège dans l'avion, sauf si les parents en font la demande et payent une place supplémentaire. Précisons ici que cette disposition n’est valable que si l’enfant a moins de 2 ans pendant toute la période du voyage. Autrement dit, si l’enfant dépasse l’âge de 2 ans avant la date de retour, il devra voyager avec un billet aller-retour au tarif enfant, et disposera donc d’un siège dans l’avion. En cas de non-respect de cette règle, aucun remboursement ne pourra être réclamé pour les frais occasionnés.",
                "3": "Les enfants de moins de 14 ans non accompagnés ne seront acceptés sur le vol que si les Conditions spécifiques du partenaire le permettent.",
                "4": "Les enfants doivent être impérativement en possession de papiers d'identité en cours de validité et à leur nom, et cela quel que soit leur âge."
              }
            },
            "7": {
              "title": "3.7 Quelques précisions à l’attention de l’utilisateur",
              "text": {
                "1": "Amplitudes n’a pas la possibilité de décider de l’attribution d’un siège, même lorsqu’il a été réservé avec la compagnie aérienne. Amplitudes ne peut donc en aucun cas garantir que certains sièges soient disponibles le jour du départ.",
                "2": "Les informations concernant le temps de trajet dans l’avion sont fournies par le partenaire à titre indicatif, et sont susceptibles d’être modifiées ou confirmées. Amplitudes n’a aucun contrôle sur ces informations, et ne pourra donc pas en assumer la responsabilité.",
                "3": "Dans le cas où l’utilisateur a réservé un vol aller-retour, mais n’a pas utilisé le vol aller, les compagnies aériennes se réservent le droit, selon les conditions, d’annuler le vol de retour sans aucun remboursement. Il en va de même si l’utilisateur n’a pas pris le vol de retour qu’il a réservé. Les coupons de vols doivent impérativement être utilisés dans l'ordre chronologique, conformément aux dates du parcours renseignées dans la réservation. Toute utilisation non conforme du billet entrainera le paiement d’un supplément prix variable en fonction des Conditions spécifiques du partenaire.",
                "4": "S’il s’agit d’un vol spécifique ou charter, le nom de la compagnie aérienne, les horaires de vol, le type d'avion, l'itinéraire et les éventuels arrêts intermédiaires sont fournis à titre exclusivement indicatif.",
                "5": "Certaines compagnies aériennes facturent des frais supplémentaires pour le repas, les bagages ou encore la sélection des sièges. Amplitudes ne pourra pas être tenu pour responsable de ces frais. Toute information sur le site concernant ces frais sont donnés à titre indicatif, et sont susceptibles d’être modifiées à tout moment par les compagnies aériennes.",
                "6": "Lorsque la ville de destination comporte plusieurs aéroports, alors le nom de l’aéroport est renseigné à titre indicatif et est susceptible d’être modifié.",
                "7": "Il est recommandé à l’utilisateur de veiller à prévoir un délai suffisant lors de la réservation pour ne pas avoir de retard si le voyage comprend une correspondance, un transit, ou un changement d’aéroport."
              }
            },
            "8": {
              "title": "3.8 Billets",
              "sub-section": {
                "1": {
                  "title": "3.8.1 Propriétés des billets",
                  "text": {
                    "1": "Les billets fournis à l’utilisateur sont nominatifs. Rappelons ici que seul le passager dont le nom est renseigné sur le billet peut bénéficier de la prestation fournie par le transporteur aérien. L’identité du détenteur du billet peut être vérifiée à tout moment.",
                    "2": "Le passager qui détient le billet n’est pas autorisé à le transférer ou à le céder à qui que ce soit, sauf disposition contraire conformément aux conditions.",
                    "3": "Le billet est, et demeure à tout moment, la propriété du transporteur."
                  }
                },
                "2": {
                  "title": "3.8.2 Billet électronique",
                  "text": {
                    "1": "Le billet électronique est un billet non matérialisé. Pour obtenir sa carte d’embarquement, le passager doit se présenter au comptoir d’embarquement de la compagnie aérienne concernée, muni de ses documents de voyage. Il est donc important de respecte r les délais impartis pour l'enregistrement. L’utilisateur peut également effectuer son enregistrement sur le site du partenaire, mais cette manœuvre reste sous sa seule responsabilité. Dans ce cas, il est recommandé de consulter préalablement les conditions spécifiques à cet enregistrement.",
                    "2": "Amplitudes propose parfois à ses utilisateurs de réserver une combinaison de deux billets simples au lieu d’un billet aller-retour. Cette offre permet de proposer un plus large choix de billets d'avion, et souvent à un prix inférieur. Les billets peuvent alors être combinés sur une même compagnie aérienne ou sur deux compagnies différentes.",
                    "3": "Contrairement aux billets aller-retour, le billet simple est soumis à ses propres règles, limitations et frais. Autrement dit, lorsque l’utilisateur réserve deux billets simples, un contrat spécifique est mis en place avec chacun des partenaires, et l’utilisateur sera soumis aux Conditions spécifiques de chaque partenaire.",
                    "4": "Dans le cas où l'un de ces deux vols est modifié par la compagnie aérienne (par exemple à cause d’une annulation ou d’un report) obligeant ainsi l'utilisateur à modifier son autre billet d'avion, ce dernier prendra en charge la totalité des frais liés aux modifications apportées à ce billet d'avion."
                  }
                },
                "3": {
                  "title": "3.8.3 Modification d’un billet",
                  "text": {
                    "1": "Toute demande de modification de billet doit se faire auprès d’Amplitudes par courrier électronique à l’adresse ",
                    "1-link": "airbus@amplitudes.com",
                    "2": " ou par téléphone au numéro indiqué sur la page d’accueil du site. Amplitudes sollicitera s’il y a lieu l’accord du transporteur ou de l’agent agréé, et agira en fonction des modalités et tarifs définis par le transporteur ou l’agent agréé.",
                    "3": "La modification d’un billet suppose l’annulation de la réservation initiale et une nouvelle réservation. A ce titre, des frais d’annulation de 10€ par billet ainsi que des frais d’émission du nouveau billet selon le barème contractuel établi pour l’AISC seront facturés par Amplitudes.",
                    "4": "Par ailleurs, plusieurs tarifs ne sont exclusivement valables que pour les dates et vols indiqués sur le billet, et ne peuvent donc être modifiés, à moins de payer un complément tarifaire. Il est de la responsabilité de l’utilisateur de se renseigner auprès d’Amplitudes sur les conditions de modification applicables à son billet."
                  }
                }
              }
            },
            "9": {
              "title": "3.9 Taxes de transport",
              "text": "Les taxes sont fixées par le gouvernement du pays. Elles incluent les redevances passagères et les taxes aéroportuaires. Il est obligatoire de payer les taxes de transport lors de la réservation d’un vol."
            },
            "10": {
              "title": "3.10 Bagages",
              "sub-section": {
                "1": {
                  "title": "3.10.1 Franchise de bagages",
                  "text": "Le passager est autorisé à voyager en franchise d’une quantité de bagages (en nombre ou en poids). La franchise est renseignée sur le billet, ou sur l’itinéraire et le reçu s’il s’agit d'un billet électronique ou d'un titre de transport. La franchise des bagages dépend de chaque transporteur."
                },
                "2": {
                  "title": "3.10.2 Excédent de bagages",
                  "text": {
                    "1": "Si les bagages enregistrés dépassent les limites de poids et de dimensions autorisées par le transporteur, il sera demandé au passager de payer un supplément tarifaire. Les informations concernant l’excédent de bagages et le supplément tarifaire (montants et modalités de paiement) sont disponibles auprès du transporteur ou des agents agréés.",
                    "2": "Rappelons ici que pour des raisons de sécurité, les bagages ne doivent pas dépasser le poids maximal fixé par le transporteur."
                  }
                },
                "3": {
                  "title": "3.10.3 Articles dangereux",
                  "text": {
                    "1": "Il est strictement interdit de prendre avec soi à bord de l'aéronef tout article que le transporteur estime susceptible de porter atteinte à la sécurité de l'aéronef, des biens ou de toute personne à bord.",
                    "2": "Il est interdit d’introduire dans la cabine de l'aéronef une arme à feu, ou tout autre type d’arme, ancienne ou récente, ni même une réplique de ces types d'armes, comme par exemple un jouet.",
                    "3": "Il est également interdit d’introduire dans la cabine de l'aéronef une épée, un couteau, un arc, une flèche, ou toute autre arme ou objet similaire."
                  }
                },
                "4": {
                  "title": "3.10.4 Conditions de refus de transport des bagages enregistrés ",
                  "text": "Le transporteur se réserve le droit de refuser des bagages enregistrés s’il considère qu’ils ne sont pas conditionnés convenablement et de manière sûre dans des contenants adaptés."
                },
                "5": {
                  "title": "3.10.5 Fouilles, contrôles et radiographies des passagers et des bagages",
                  "text": {
                    "1": "Pour des raisons de sécurité, le transporteur, ou un agent agréé, peut exercer une fouille ou un contrôle sur le passager. Il peut également procéder à une fouille, un contrôle ou une radiographie sur les bagages du passager.",
                    "2": "Le transporteur ou l’agent agréé s’efforcera de fouiller, contrôler ou radiographier les bagages sous la présence du passager. Toutefois, si le passager n’est pas disponible, ses bagages pourront être fouillés, contrôlés et/ou radiographiés en son absence.",
                    "3": "Le transporteur peut refuser de transporter un passager ou ses bagages, si le passager s’oppose à une fouille, un contrôle ou une radiographie de sûreté et de sécurité.",
                    "4": "Le transporteur ne pourra pas être tenu pour responsable si lors d’une fouille, d’un contrôle, ou d’une radiographie, le passager, ou ses bagages, subissent un dommage, excepté si le dommage est directement et exclusivement le fait de la négligence ou de la faute du transporteur ou de l’agent agréé."
                  }
                },
                "6": {
                  "title": "3.10.6 Bagages enregistrés",
                  "text": {
                    "1": "Il est conseillé aux passagers d’indiquer sur leurs bagages de manière claire et lisible leur nom, prénom et adresse. Lors de l’enregistrement des bagages, le transporteur remet au passager une fiche d'identification pour chaque bagage.",
                    "2": "Pour des raisons de sûreté et de sécurité, ou pour des raisons opérationnelles, le transporteur peut décider de transporter les bagages enregistrés par un même passager dans des vols différents. Dans ce cas, c’est au transporteur de livrer au passager les bagages ayant été transportés sur un autre vol, à moins que le droit en vigueur exige la présence du passager lors des contrôles douaniers."
                  }
                },
                "7": {
                  "title": "3.10.7 Bagages à main",
                  "text": {
                    "1": "Les dimensions et le poids maximum des bagages à main est déterminé discrétionnairement par le transporteur. Pour rappel, les bagages doivent pouvoir tenir sous le siège devant le passager ou entrer dans un compartiment à bagage de la cabine.",
                    "2": "Si le bagage à main ne respecte pas les conditions fixées par le transporteur (poids, dimensions, et autre), alors il sera considéré comme un bagage en soute. Le passager devra alors le faire enregistrer.",
                    "3": "Si un bagage excède les dimensions et le poids maximum fixés par le transporteur pour les bagages à main, mais qu’il ne remplit pas les conditions requises pour être transporté en tant que bagage enregistré, le transporteur peut autoriser à titre exceptionnel le passager à le mettre dans la cabine de l’aéronef si, cumulativement:",
                    "4": "Le passager a informé le transporteur avant de s’enregistrer, qu’il souhaite que son bagage soit rangé dans la cabine de l’aéronef;",
                    "5": "Le transporteur a autorisé, avant l’enregistrement, que le bagage soit rangé dans la cabine de l'aéronef;",
                    "6": "Le passager s’est acquitté des frais supplémentaires applicables pour ce service, conformément aux tarifs en vigueur le jour de l’enregistrement."
                  }
                },
                "8": {
                  "title": "3.10.8 Collecte et livraison des bagages enregistrés transportés en soute",
                  "text": {
                    "1": "Le passager est tenu de récupérer ses bagages enregistrés dès que le transporteur les met à sa disposition. Si le passager tarde à le faire, le transporteur est en droit de lui facturer des frais de garde. Le passager a trois mois à compter de la date de remise des bagages pour les récupérer. Ce délai dépassé, le transporteur pourra les détruire sans que le passager ne puisse l’en tenir pour responsable.",
                    "2": "Seul le passager détenant la fiche d'identification de bagage et le bulletin de bagages (si celui-ci a été émis) est autorisé à réclamer le bagage enregistré.",
                    "3": "Si toutefois la personne qui réclame un bagage enregistré est dans l’incapacité de présenter la fiche d'identification de bagage, alors que celle-ci a été émise lors de l’enregistrement, le transporteur peut lui remettre le bagage à condition que la personne soit en mesure de prouver que le bagage lui appartient."
                  }
                },
                "9": {
                  "title": "3.10.9 Animaux",
                  "text": "Le transport des animaux est admis par certaines compagnies. Ce service est soumis à l’acceptation et aux conditions du transporteur."
                }
              }
            },
            "11": {
              "title": "3.11 Tarifs spéciaux",
              "text": {
                "1": "Certaines compagnies aériennes proposent des tarifs spéciaux pour les enfants de moins de 2 ans, les enfants et les seniors. Ces offres dépendent de la compagnie aérienne et du vol concernés, ainsi que de la disponibilité des places, et de l'âge des voyageurs.",
                "2": "La réduction relative au tarif enfant peut varier en fonction du tarif adulte appliqué par la compagnie aérienne pour le vol concerné. Il arrive donc parfois que le tarif enfant soit le même que le tarif adulte renseigné sur le site."
              }
            }
          }
        },
        "4": {
          "title": "Article 4. Conditions financières et modes de paiement",
          "text": {
            "1": "Les prix des prestations renseignées sur le site sont indiqués en euros, et ne comprennent pas les éventuelles taxes locales d’entrée ou de sortie imposées par certains pays, excepté si les Conditions spécifiques comprennent des mentions particulières contraires.",
            "2": "Le règlement du total du prix des prestations réservées sur le site ou par téléphone s'effectue auprès de l’AISC qui a son tour règle Amplitudes selon les conditions contractuelles.",
            "3": "Le prix des prestations est celui mentionné sur le site, sauf cas d'erreur manifeste. Les prix peuvent être modifiés à tout moment, mais ces changements n’auront pas d’incidence sur les réservations déjà acceptées, sauf dans les cas indiqués dans les présentes Conditions de vente. Amplitudes applique des frais de réservation et de mise en remboursement des prestations aériennes. L'utilisateur sera informé de tous les frais applicables lors de la réservation. Amplitudes s’efforce d’être vigilant, mais il peut arriver que le prix de certaines prestations mentionné sur le site soit erroné. Amplitudes se réserve expressément le droit de corriger ces erreurs sur le site, et de s’occuper des réservations réalisées sous un prix erroné. Amplitudes offrira à l’utilisateur, sous réserve de disponibilité, la possibilité de conserver sa réservation au prix corrigé, ou annulera la réservation sans aucune pénalité. Amplitudes n'a aucune obligation de fournir des prestations à un prix erroné qui serait plus bas à un utilisateur, et ce, même si l'utilisateur a reçu la confirmation de sa réservation.",
            "4": "Les coûts et les frais de service correspondent aux coûts liés aux prestations et qui sont supportés par les partenaires, notamment les taxes indirectes (TVA ou autres taxes similaires) et les autres frais nécessaires pour la gestion des réservations.",
            "5": "Hormis les cas mentionnés dans les présentes Conditions de vente concernant les taxes sur les montants retenus pour la fourniture de nos services, Amplitudes certifie ne pas collecter de taxes pour les reverser aux autorités fiscales compétentes."
          }
        },
        "5": {
          "title": "Article 5. Service utilisateurs et réclamations",
          "section": {
            "1": {
              "title": "5.1 Service utilisateurs",
              "text": {
                "1": "Conformément à la politique de confidentialité des données personnelles collectées et à la RGPD, l'utilisateur dispose à tout moment, d'un droit d'accès, de modification, de rectification et de suppression des données qui le concernent. L’utilisateur peut faire valoir ces droits en envoyant une requête par courrier électronique à l'adresse suivante: ",
                "2": "dpo@amplitudes.com",
                "3": ", sous réserve de justifier son identité."
              }
            },
            "2": {
              "title": "5.2 Service réclamations",
              "text": {
                "1": "Toute réclamation ou demande d’informations doit être adressé à Amplitudes, dans les 30 jours suivants la fin du séjour, à l’adresse électronique: ",
                "2": "airbus@amplitudes.com",
                "3": "Amplitudes ne prendra en compte les réclamations que lorsque les difficultés dont elles font l’objet lui auront été préalablement signalées, ou si lors du voyage il y a eu une requête auprès du partenaire concerné pour tenter de limiter le préjudice subi par l’utilisateur. Toutefois, en fonction des circonstances, des exceptions pourront éventuellement être admises.",
                "4": "Les bagages, les vêtements, et autres objets personnels sont placés sous la surveillance de l’utilisateur. Aucune réclamation ne sera donc acceptée en cas de perte, avarie ou vol, sauf s’il est prouvé qu’il y a eu une faute de la part d’Amplitudes ou d’un de ses partenaires. Les bagages enregistrés auprès d'une compagnie aérienne ne sont assurés que pendant la durée du transport."
              }
            }
          }
        },
        "6": {
          "title": "Article 6. Responsabilités et garanties",
          "text": "Sauf en cas de dispositions légales contraires, Amplitudes ne pourra pas être tenu pour responsable conformément aux contrats de prestations que l'utilisateur aura conclu avec un ou plusieurs partenaire(s) et notamment lorsque le dommage est imputable à l'utilisateur, ou au fait, imprévisible et insurmontable, d'un tiers étranger à la fourniture des prestations prévues au contrat, ou à un cas de force majeure."
        },
        "7": {
          "title": "Article 7. Protection des données personnelles",
          "text": "La Convention de collaboration signée entre l’AISC et Amplitudes fixe les conditions d’utilisation des données personnelles auxquelles se sont engagées les deux parties. Elles sont disponibles auprès de l’AISC."
        },
        "8": {
          "title": "Article 8. Droit applicable",
          "text": {
            "1": "Les présentes Conditions générales de vente sont soumises au droit français. Tout litige relatif à leur interprétation et/ou à leur exécution sera pris en charge par les Tribunaux de Toulouse.",
            "2": "En cas de différend entre Amplitudes et l’utilisateur, ce dernier peut recourir à une procédure de médiation conventionnelle, ou s’il le souhaite à un autre mode alternatif de règlement des litiges, conformément à ce qui est défini dans le droit français, notamment par les articles 1528 et suivants du Code de procédure civile.",
            "3": "Amplitudes dépend du médiateur de la consommation tourisme et voyage (",
            "3-link": "http://www.mtv.travel/",
            "4": "). Dans le cas où après avoir saisi par écrit le service réclamation d’Amplitudes, l’utilisateur n’obtient aucune réponse qui le satisfasse dans un délai de 60 jours, il est en droit de faire appel au médiateur tourisme et voyage, dans les conditions et modalités de saisie prévues sur le site du médiateur. Il est possible de contacter le médiateur tourisme et voyage à l’adresse suivante: ",
            "5": "MTV Médiation Tourisme Voyage",
            "6": "BP 80 303",
            "7": "75 823 Paris Cedex 17",
            "8": "Vous pouvez également soumettre vos litiges via la plateforme de règlement en ligne des litiges de la Commission européenne disponible à l'adresse suivante: ",
            "8-link": "http://ec.europa.eu/odr"
          }
        },
        "9": {
          "title": "Article 9. Formalités d’assurances",
          "text": {
            "1": "L’AISC ayant elle-même souscrit le 1er Septembre 2004 un contrat auprès de la compagnie Axa sous le numéro 0800594*04, couvrant l’ensemble de ses ouvrant-droits lorsqu’ils partent dans le cadre d’un voyage individuel ou de groupe par son intermédiaire.",
            "2": "L’AISC demande expressément à Amplitudes de ne pas assurer ses ouvrant-droit dans le cadre des garanties annulation, bagages, assistance rapatriement, médicale et juridique.",
            "3": "Par accord mutuel, AMPLITUDES s'abstiendra de proposer l'assurance annulation facultative que l’AISC proposera aux ouvrant-droit lors de la confirmation.",
            "4": "En cas d'annulation, l’ouvrant-droit s'adressera directement à l’AISC et non à AMPLITUDES."
          },
          "section": {
            "1": {
              "title": "9.1 Responsabilité",
              "text": "Amplitudes, de même que son assureur Mutuaide Assistance (8-14 avenue des Frères Lumière, 94368 Bry-sur-Marne CEDEX), ne sauraient être engagés pour des manquements ou contretemps à l’exécution de ses obligations qui résulteraient de cas de force majeure, ou d’événements tels que la guerre civile ou étrangère, les émeutes ou mouvements populaires, le lock-out, les grèves , les attentats, les actes de terrorisme, les pirateries, les tempêtes et ouragans, les tremblements de terre, les cyclones, les éruptions volcaniques ou autres cataclysmes (faisant l’objet de la procédure visée par la loi N° 82.600 du 13 juillet 1982), la désintégration du noyau atomique, l’explosion d’engins et les effets nucléaires radioactifs, les épidémies, les effets de la pollution et catastrophes naturelles, les effets de radiation ou tout autre cas fortuit ou de force majeure, ainsi que leurs conséquences."
            },
            "2": {
              "title": "9.2 Responsabilité civile professionnelle",
              "text": {
                "1": "Amplitudes a souscrit auprès de AXA Assurances (21 place Dupuy - 31000 Toulouse) une assurance de Responsabilité civile professionnelle (contrat n° 0539538504).",
                "2": "Cette assurance est engagée lorsque les conséquences de la Responsabilité civile professionnelle incombent à l’assuré en raison de dommage(s) corporel(s), matériel(s) et immatériel(s) causés à ses clients ou à des tiers à la suite de fautes, erreurs ou négligences commises durant l’exercice de sa fonction."
              }
            }
          }
        },
        "10": {
          "title": "Article 10. Dispositions finales",
          "text": {
            "1": "Le fait qu'Amplitudes ne se prévale pas, à un moment donné, d'une des dispositions des Conditions générales de vente ne pourra pas être interprété comme une renonciation par elle-même à se prévaloir ultérieurement de l'une de ces dispositions.",
            "2": "Dans le cas où l'une des dispositions des Conditions générales de vente serait déclarée nulle ou sans effet, elle serait réputée non écrite, sans que cela n'affecte la validité des autres dispositions, excepté si la disposition déclarée nulle ou sans effet s’avère essentielle et déterminante.",
            "3": "Tout cas de force majeure suspend les obligations des présentes affectées par le cas de force majeure et libère de toute responsabilité la partie qui aurait dû exécuter l'obligation."
          }
        }
      }
    },
    "partners-conditions": {
      "title": "Conditions spécifiques des partenaires",
      "text": "Sur cette page vous trouverez les liens donnant accès aux conditions de transport des compagnies aériennes, ainsi qu’à leur politique en matière de bagages. Vous y trouverez également la procédure à suivre pour l’enregistrement en ligne et des indications concernant vos réservations.",
      "online-registration": {
        "title": "Enregistrement en ligne",
        "text": {
          "1": "Pour gagner du temps à l’aéroport, il est possible d’effectuer votre enregistrement en ligne sur le site de la compagnie à bord de laquelle vous allez voyager. Il est généralement possible de s’enregistrer à partir de 36 heures avant votre heure de départ. Ceci varie selon les compagnies. Après vous être enregistré en ligne, vous pourrez imprimer vos cartes d'embarquement ou les sauvegarder sur votre téléphone mobile afin de pouvoir les présenter lors de l’embarquement.",
          "2": "Pour procéder à un enregistrement en ligne, cliquez sur le lien ci-dessous de la compagnie aérienne auprès de laquelle vous avez réservé vos vols. Ce lien vous mènera directement à la page d’enregistrement en ligne.",
          "3": "Nous précisons que cette liste n’est pas exhaustive. Toutefois, il est possible que la compagnie aérienne avec laquelle vous voyagez ne propose pas ce service, et par conséquent elle ne sera pas répertoriée sur cette liste. Auquel cas vous devrez vous enregistrer à l'aéroport."
        }
      },
      "baggage": {
        "title": "Bagages",
        "text": "Les franchise et les politiques commerciales concernant les bagages varient en fonction des compagnies aériennes. Il est fortement recommandé de se renseigner en consultant les Conditions de transport des compagnies aériennes à bord desquelles vous voyagez."
      },
      "low-cost-carriers": {
        "title": "Transporteurs à bas coût ou low-cost",
        "text": {
          "1": "La plupart des compagnies aériennes dites à bas coût, ou low-cost, n’incluent pas l’enregistrement des bagages dans leurs tarifs de base.",
          "2": "Ainsi si vous avez choisi un tarif sans bagage lors de votre réservation et que finalement vous allez voyager avec un bagage nous vous conseillons d’enregistrer votre bagage en ligne avant votre départ. Les frais qui vous seront alors demandés seront en général moindres que ceux qui vous seront facturés à l’aéroport le jour de votre départ.",
          "3": "Pour effectuer un enregistrement de bagage, vous avez besoin de votre numéro de réservation, de votre adresse électronique et de votre carte de crédit si vous avez initialement réservé un tarif sans bagages."
        }
      },
      "regular-carriers": {
        "title": "Transporteurs réguliers",
        "text": {
          "1": "Les compagnies aériennes qui proposent un service complet sont appelées transporteurs réguliers. Selon que le passager voyage en classe Économie ou Affaires, les transporteurs réguliers n’appliquent pas la même franchise bagage.",
          "2": "Pour les passagers qui voyagent en classe Économie la franchise est généralement limitée à un poids maximum de 23 kg. En revanche pour les personnes voyageant en classe Affaires il est généralement autorisé d’avoir un bagage de 32 kg maximum sans frais supplémentaires.",
          "3": "Attention, de nombreuses compagnies régulières proposent des tarifs sans bagage en particulier sur les vols court courrier.",
          "4": "Nous vous conseillons dans tous les cas de consulter les Conditions de transport de la compagnie aérienne à bord de laquelle vous allez voyager pour connaitre sa politique globale et en particulier en matière de transport de bagages."
        }
      },
      "mandatory-travel-documents": {
        "title": "Documents de voyage obligatoires",
        "text": {
          "1": "Les formalités à accomplir et les documents de voyage nécessaires sont l’objet de changements fréquents de la part des autorités nationales. Nous vous conseillons très fortement avant d’entreprendre votre voyage de consulter le site du Ministère des Affaires Etrangères en suivant ce lien: ",
          "1-link": "https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/",
          "2": "Dans le cas d’une vente de vol seul, Amplitudes ne saurait être tenu pour responsable d’un refus d’embarquement du fait d’un défaut de présentation d’un document ou de réalisation d’une formalité préalable au départ."
        }
      }
    }
  }
}
</i18n>

<template>
  <div>
    <v-card
      class="mx-auto my-8"
      max-width="70%"
    >
      <v-card-text data-cy="general-terms-and-conditions-card">
        <div id="general-terms-and-conditions">
          <h1>{{ $t('tac-flight.title') }}</h1>
          <div
            id="contact-information"
            class="mt-4"
          >
            <div>
              <p>{{ $t('tac-flight.contact-information.1') }}</p>
              <p>{{ $t('tac-flight.contact-information.2') }}</p>
            </div>
          </div>

          <div
            id="article-1"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.1.title') }}</h2>

            <div
              id="section-1-1"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.1.section.1.title') }}</h3>
              <p>{{ $t('tac-flight.article.1.section.1.text.1') }}</p>
              <p>{{ $t('tac-flight.article.1.section.1.text.2') }}</p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.3') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.4') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.5') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.6') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.7') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.8') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.9') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.10') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.11') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.12') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.13') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.14') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.15') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.16') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.17') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.18') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.19') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.20') }}</span>
              </p>
              <p>
                <span class="font-weight-bold">{{ $t('tac-flight.article.1.section.1.text.21') }}</span><br>
                <span>{{ $t('tac-flight.article.1.section.1.text.22') }}</span>
              </p>
            </div>

            <div
              id="section-1-2"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.1.section.2.title') }}</h3>
              <p>{{ $t('tac-flight.article.1.section.2.text.1') }}</p>
              <p>{{ $t('tac-flight.article.1.section.2.text.2') }}</p>
              <p>
                {{ $t('tac-flight.article.1.section.2.text.3') }}
                <a href="#partners-conditions">{{ $t('tac-flight.article.1.section.2.text.3-href') }}</a>
              </p>
              <p>{{ $t('tac-flight.article.1.section.2.text.4') }}</p>
            </div>
          </div>

          <div
            id="article-2"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.2.title') }}</h2>

            <div
              id="section-2-1"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.1.title') }}</h3>
              <p>{{ $t('tac-flight.article.2.section.1.text.1') }}</p>
              <p>{{ $t('tac-flight.article.2.section.1.text.2') }}</p>
              <p>{{ $t('tac-flight.article.2.section.1.text.3') }}</p>
            </div>

            <div
              id="section-2-2"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.2.title') }}</h3>

              <div
                id="sub-section-2-2-1"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.2.section.2.sub-section.1.title') }}</h4>

                <div
                  id="sub-sub-section-2-2-1-1"
                  class="sub-sub-section"
                >
                  <h5>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.title') }}</h5>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.1') }}</span>
                    <a
                      href="http://www.diplomatie.gouv.fr/fr/"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.1-link') }}</a>.
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.2') }}
                  </p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.3') }}</p>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.4') }}</span>
                    <a
                      href="http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/conseils-par-pays/"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.4-link') }}</a>.
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.5') }}
                  </p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.6') }}</p>
                  <p class="font-weight-bold">
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.7') }}
                  </p>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.8') }}</span>
                    <a
                      href="http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/infos-pratiques-20973/preparer-son-depart-20975/formalites-administratives/article/formalites-administratives"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.8-link') }}</a>.
                  </p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.9') }}</p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.10') }}</p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.11') }}</p>
                  <p class="font-weight-bold">
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.12') }}
                  </p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.13') }}</p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.14') }}</p>
                  <p class="font-weight-bold">
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.15') }}
                  </p>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.16') }}</span>
                    <a
                      href="https://esta.cbp.dhs.gov/esta"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.1.text.16-link') }}</a>
                  </p>
                </div>

                <div
                  id="sub-sub-section-2-2-1-2"
                  class="sub-sub-section"
                >
                  <h5>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.title') }}</h5>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.1') }}</span>
                    <a
                      href="http://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.1-link') }}</a>.
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.1-end') }}</span>
                  </p>
                  <p class="font-weight-bold">
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.2') }}
                  </p>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.3') }}</span>
                    <a
                      href="http://www.pasteur.fr/fr/map"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.3-link') }}</a>.
                  </p>
                  <p class="font-weight-bold">
                    {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.4') }}
                  </p>
                  <p>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.5') }}</p>
                  <ul>
                    <li>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.6') }}</li>
                    <li>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.7') }}</li>
                  </ul>
                  <p>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.8') }}</span>
                    <a
                      href="http://www.developpement-durable.gouv.fr/-Passagers-aeriens-s-informer-pour-.html"
                      target="_blank"
                    >{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.8-link') }}</a>
                    <span>{{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.9') }}</span>
                    <a
                      href="http://www.sante.gouv.fr/controle-sanitaire-dans-les-aeroports.html"
                      target="_blank"
                    >
                      {{ $t('tac-flight.article.2.section.2.sub-section.1.sub-sub-section.2.text.9-link') }}
                    </a>
                  </p>
                </div>
              </div>

              <div
                id="sub-section-2-2-2"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.2.section.2.sub-section.2.title') }}</h4>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.2.text.1') }}</p>
                <ul>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.2.text.2') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.2.text.3') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.2.text.4') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.2.text.5') }}</li>
                </ul>
              </div>

              <div
                id="sub-section-2-2-3"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.2.section.2.sub-section.3.title') }}</h4>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.1') }}</p>
                <ul>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.2') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.3') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.4') }}</li>
                  <li>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.5') }}</li>
                </ul>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.3.text.6') }}</p>
              </div>

              <div
                id="sub-section-2-2-4"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.2.section.2.sub-section.4.title') }}</h4>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.4.text.1') }}</p>
              </div>

              <div
                id="sub-section-2-2-5"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.2.section.2.sub-section.5.title') }}</h4>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.5.text.1') }}</p>
                <p>{{ $t('tac-flight.article.2.section.2.sub-section.5.text.2') }}</p>
              </div>
            </div>

            <div
              id="section-2-3"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.3.title') }}</h3>
              <p>{{ $t('tac-flight.article.2.section.3.text.1') }}</p>
              <p>
                <span>{{ $t('tac-flight.article.2.section.3.text.2') }}</span>
                <a href="#partners-conditions">{{ $t('tac-flight.article.2.section.3.text.2-link') }}</a>
              </p>
              <p>
                <span>{{ $t('tac-flight.article.2.section.3.text.3') }}</span>
                <a href="mailto:airbus@amplitudes.com">{{ $t('tac-flight.article.2.section.3.text.3-link') }}</a>.
                <span>{{ $t('tac-flight.article.2.section.3.text.4') }}</span>
              </p>
              <p>{{ $t('tac-flight.article.2.section.3.text.5') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.6') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.7') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.8') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.9') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.10') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.11') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.12') }}</p>
              <p>{{ $t('tac-flight.article.2.section.3.text.13') }}</p>
              <p>
                <span>{{ $t('tac-flight.article.2.section.3.text.14') }}</span>
                <a href="mailto:airbus@amplitudes.com">{{ $t('tac-flight.article.2.section.3.text.14-link') }}</a>.
                <span>{{ $t('tac-flight.article.2.section.3.text.15') }}</span>
              </p>
              <p>{{ $t('tac-flight.article.2.section.3.text.16') }}</p>
            </div>

            <div
              id="section-2-4"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.4.title') }}</h3>
              <p>{{ $t('tac-flight.article.2.section.4.text.1') }}</p>
              <p>{{ $t('tac-flight.article.2.section.4.text.2') }}</p>
            </div>

            <div
              id="section-2-5"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.5.title') }}</h3>
              <p>{{ $t('tac-flight.article.2.section.5.text') }}</p>
            </div>

            <div
              id="section-2-6"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.2.section.6.title') }}</h3>
              <p>{{ $t('tac-flight.article.2.section.6.text.1') }}</p>
              <p>{{ $t('tac-flight.article.2.section.6.text.2') }}</p>
            </div>
          </div>

          <div
            id="article-3"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.3.title') }}</h2>
            <p>{{ $t('tac-flight.article.3.text.1') }}</p>

            <div
              id="section-3-1"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.1.title') }}</h3>
              <p>
                <span>{{ $t('tac-flight.article.3.section.1.text.1') }}</span>
                <a
                  href="#"
                >{{ $t('tac-flight.article.3.section.1.text.1-link') }}</a>
              </p>
              <p>{{ $t('tac-flight.article.3.section.1.text.2') }}</p>
            </div>

            <div
              id="section3-2"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.2.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.2.text.1') }}</p>
              <p>{{ $t('tac-flight.article.3.section.2.text.2') }}</p>
              <p>{{ $t('tac-flight.article.3.section.2.text.3') }}</p>
            </div>

            <div
              id="section-3-3"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.3.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.3.text') }}</p>
            </div>

            <div
              id="section-3-4"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.4.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.4.text.1') }}</p>
              <p>{{ $t('tac-flight.article.3.section.4.text.2') }}</p>
              <p>{{ $t('tac-flight.article.3.section.4.text.3') }}</p>
            </div>

            <div
              id="section-3-5"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.5.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.5.text.1') }}</p>
              <p>{{ $t('tac-flight.article.3.section.5.text.2') }}</p>
            </div>

            <div
              id="section-3-6"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.6.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.6.text.1') }}</p>
              <p>{{ $t('tac-flight.article.3.section.6.text.2') }}</p>
              <p>{{ $t('tac-flight.article.3.section.6.text.3') }}</p>
              <p>{{ $t('tac-flight.article.3.section.6.text.4') }}</p>
            </div>

            <div
              id="section-3-7"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.7.title') }}</h3>
              <ul>
                <li>{{ $t('tac-flight.article.3.section.7.text.1') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.2') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.3') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.4') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.5') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.6') }}</li>
                <li>{{ $t('tac-flight.article.3.section.7.text.7') }}</li>
              </ul>
            </div>

            <div
              id="section-3-8"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.8.title') }}</h3>

              <div
                id="sub-section-3-8-1"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.8.sub-section.1.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.1.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.1.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.1.text.3') }}</p>
              </div>

              <div
                id="sub-section-3-8-2"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.8.sub-section.2.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.2.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.2.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.2.text.3') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.2.text.4') }}</p>
              </div>

              <div
                id="sub-section-3-8-3"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.8.sub-section.3.title') }}</h4>
                <p>
                  <span>{{ $t('tac-flight.article.3.section.8.sub-section.3.text.1') }}</span>
                  <a href="mailto:airbus@amplitudes.com">{{
                    $t('tac-flight.article.3.section.8.sub-section.3.text.1-link') }}</a>
                  <span>{{ $t('tac-flight.article.3.section.8.sub-section.3.text.2') }}</span>
                </p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.3.text.3') }}</p>
                <p>{{ $t('tac-flight.article.3.section.8.sub-section.3.text.4') }}</p>
              </div>
            </div>

            <div
              id="section-3-9"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.9.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.9.text') }}</p>
            </div>

            <div
              id="section-3-10"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.10.title') }}</h3>

              <div
                id="sub-section-3-10-1"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.1.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.1.text') }}</p>
              </div>

              <div
                id="sub-section-3-10-2"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.2.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.2.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.2.text.2') }}</p>
              </div>

              <div
                id="sub-section-3-10-3"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.3.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.3.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.3.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.3.text.3') }}</p>
              </div>

              <div
                id="sub-section-3-10-4"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.4.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.4.text') }}</p>
              </div>

              <div
                id="sub-section-3-10-5"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.5.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.5.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.5.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.5.text.3') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.5.text.4') }}</p>
              </div>

              <div
                id="sub-section-3-10-6"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.6.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.6.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.6.text.2') }}</p>
              </div>

              <div
                id="sub-section-3-10-7"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.7.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.3') }}</p>
                <ul>
                  <li>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.4') }}</li>
                  <li>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.5') }}</li>
                  <li>{{ $t('tac-flight.article.3.section.10.sub-section.7.text.6') }}</li>
                </ul>
              </div>

              <div
                id="sub-section-3-10-8"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.8.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.8.text.1') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.8.text.2') }}</p>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.8.text.3') }}</p>
              </div>

              <div
                id="sub-section-3-10-9"
                class="sub-section"
              >
                <h4>{{ $t('tac-flight.article.3.section.10.sub-section.9.title') }}</h4>
                <p>{{ $t('tac-flight.article.3.section.10.sub-section.9.text') }}</p>
              </div>
            </div>

            <div
              id="section-3-11"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.3.section.11.title') }}</h3>
              <p>{{ $t('tac-flight.article.3.section.11.text.1') }}</p>
              <p>{{ $t('tac-flight.article.3.section.11.text.2') }}</p>
            </div>
          </div>

          <div
            id="article-4"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.4.title') }}</h2>
            <p>{{ $t('tac-flight.article.4.text.1') }}</p>
            <p>{{ $t('tac-flight.article.4.text.2') }}</p>
            <p>{{ $t('tac-flight.article.4.text.3') }}</p>
            <p>{{ $t('tac-flight.article.4.text.4') }}</p>
            <p>{{ $t('tac-flight.article.4.text.5') }}</p>
          </div>

          <div
            id="article-5"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.5.title') }}</h2>

            <div
              id="section-5-1"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.5.section.1.title') }}</h3>
              <p>
                <span>{{ $t('tac-flight.article.5.section.1.text.1') }}</span>
                <a href="mailto:dpo@amplitudes.com">{{ $t('tac-flight.article.5.section.1.text.2') }}</a>
                <span>{{ $t('tac-flight.article.5.section.1.text.3') }}</span>
              </p>
            </div>

            <div
              id="section-5-2"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.5.section.2.title') }}</h3>
              <p>
                <span>{{ $t('tac-flight.article.5.section.2.text.1') }}</span>
                <a href="mailto:airbus@amplitudes.com">{{ $t('tac-flight.article.5.section.2.text.2') }}</a>.
                <span>{{ $t('tac-flight.article.5.section.2.text.3') }}</span>
              </p>
              <p>{{ $t('tac-flight.article.5.section.2.text.4') }}</p>
            </div>
          </div>

          <div
            id="article-6"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.6.title') }}</h2>
            <p>{{ $t('tac-flight.article.6.text') }}</p>
          </div>

          <div
            id="article-7"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.7.title') }}</h2>
            <p>{{ $t('tac-flight.article.7.text') }}</p>
          </div>

          <div
            id="article-8"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.8.title') }}</h2>
            <p>{{ $t('tac-flight.article.8.text.1') }}</p>
            <p>{{ $t('tac-flight.article.8.text.2') }}</p>
            <p>
              <span>{{ $t('tac-flight.article.8.text.3') }}</span>
              <a
                href="http://www.mtv.travel/"
                target="_blank"
              >{{ $t('tac-flight.article.8.text.3-link') }}</a>
              <span>{{ $t('tac-flight.article.8.text.4') }}</span>
            </p>
            <div class="text-center">
              <p>{{ $t('tac-flight.article.8.text.5') }}</p>
              <p>{{ $t('tac-flight.article.8.text.6') }}</p>
              <p>{{ $t('tac-flight.article.8.text.7') }}</p>
            </div>
            <p>
              <span>{{ $t('tac-flight.article.8.text.8') }}</span>
              <a
                href="http://ec.europa.eu/odr"
                target="_blank"
              >{{ $t('tac-flight.article.8.text.8-link') }}</a>
            </p>
          </div>

          <div
            id="article-9"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.9.title') }}</h2>
            <p>{{ $t('tac-flight.article.9.text.1') }}</p>
            <p>{{ $t('tac-flight.article.9.text.2') }}</p>
            <p>{{ $t('tac-flight.article.9.text.3') }}</p>
            <p>{{ $t('tac-flight.article.9.text.4') }}</p>

            <div
              id="section-9-1"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.9.section.1.title') }}</h3>
              <p>{{ $t('tac-flight.article.9.section.1.text') }}</p>
            </div>

            <div
              id="section-9-2"
              class="section"
            >
              <h3>{{ $t('tac-flight.article.9.section.2.title') }}</h3>
              <p>{{ $t('tac-flight.article.9.section.2.text.1') }}</p>
              <p>{{ $t('tac-flight.article.9.section.2.text.2') }}</p>
            </div>
          </div>

          <div
            id="article-10"
            class="article"
          >
            <h2>{{ $t('tac-flight.article.10.title') }}</h2>
            <p>{{ $t('tac-flight.article.10.text.1') }}</p>
            <p>{{ $t('tac-flight.article.10.text.2') }}</p>
            <p>{{ $t('tac-flight.article.10.text.3') }}</p>
          </div>
        </div>

        <div
          id="partners-conditions"
          class="mt-16"
        >
          <h1>{{ $t('partners-conditions.title') }}</h1>
          <p>{{ $t('partners-conditions.text') }}</p>

          <div class="article">
            <h2>{{ $t('partners-conditions.online-registration.title') }}</h2>
            <div>
              <p>{{ $t('partners-conditions.online-registration.text.1') }}</p>
              <p>{{ $t('partners-conditions.online-registration.text.2') }}</p>
              <p>{{ $t('partners-conditions.online-registration.text.3') }}</p>
            </div>
            <div id="airline-websites-links">
              <v-row>
                <v-col>
                  <a
                    href="https://www.airfrance.fr/FR/fr/local/core/engine/echeckin/IciFormAction.do"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AF.png"
                      alt="Air France"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.hop.fr/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/A5.png"
                      alt="Hop!"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.easyjet.com/fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/U2.png"
                      alt="Easyjet"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.ryanair.com/fr/fr/check-in"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/FR.png"
                      alt="Ryanair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://tickets.vueling.com/SearchWebCheckin.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/VY.png"
                      alt="Vueling Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.flytap.com/fr-fr/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TP.png"
                      alt="TAP Portugal"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://checkin.si.amadeus.net/1ASIHSSCWEBSS/sscwss/checkin?ln=fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SS.png"
                      alt="Corsair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://checkin.si.amadeus.net/1ASIHSSCWEBTX/sscwtx/checkin?ln=fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TX.png"
                      alt="Air Caraibes"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.lufthansa.com/fr/fr/Enregistrement-en-ligne"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/LH.png"
                      alt="Lufthansa"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.britishairways.com/fr-fr/information/checking-in?source=MNVINF3checking_in&link=main_nav"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/BA.png"
                      alt="British Airways"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.iberia.com/fr/autocheckin-online.fr/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/IB.png"
                      alt="Iberia"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.brusselsairlines.com/fr_fr/my-travel/manage-my-flight/Default.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SN.png"
                      alt="Brussels Airways"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://check-in.alitalia.com/webcheckin/fr_fr/NewCheckIn"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AZ.png"
                      alt="Alitalia"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.americanairlines.fr/intl/fr/informationVoyage/onlineCheckin.jsp?anchorEvent=false&from=Nav"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AA.png"
                      alt="American Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.aircanada.com/fr/travelinfo/traveller/checkin/checkin.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AC.png"
                      alt="Air Canada"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.airtransat.fr/fr/gammes.aspx?langid=fr&parentid=53&type=voyageur&id=83"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TS.png"
                      alt="Air Transat"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://www.emirates.com/english/manage-booking/online-check-in.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/EK.png"
                      alt="Emirates"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.norwegian.com/uk/travel-info/check-in-and-boarding/online-check-in/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/DY.png"
                      alt="Norwegian Air Shuttle"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.xl.com/fr/enregistrer-ligne"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SE.png"
                      alt="xl airways"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://checkin.jetstar.com/?culture=en-AU"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/JQ.png"
                      alt="Jetstar"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://checkin.si.amadeus.net/1ASIHSSCWEBA3/sscwa3/checkin?ln=fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/A3.png"
                      alt="Aegean"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.aeroflot.com/cms/fr/online_registration"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SU.png"
                      alt="Aeroflot-Russian Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.aerlingus.com/travelinformation/knowbeforeyoufly/check-in/web-check-infr/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/EI.png"
                      alt="Aer Lingus"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.aigle-azur.com/enregistrement-en-ligne.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/ZI.png"
                      alt="Aigle Azur"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.airasia.com/ot/en/check-ins/web-and-mobile.page?"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AK.png"
                      alt="Air Asia"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.airberlin.com/fr/webcheckin/index/index//?"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AB.png"
                      alt="airberlin"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.aireuropa.com/waeam/xwaea/1/facturacion/xfacturacion_v7.inicio_embarque.html?p_codidi=FR&amp;p_codmer=FR"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/UX.png"
                      alt="Air Europa"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.airmalta.com/home-fr-fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/KM.png"
                      alt="Air Malta"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.austrian.com/Info/CheckIn_MobileServices/WebCheckIn.aspx?sc_lang=fr&cc=FR"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/OS.png"
                      alt="Austrian Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.csa.cz/fr-fr/enregistrement/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/OK.png"
                      alt="Czech Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.egyptair.com/fr/fly/web-check-in/Pages/web-check-in.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/MS.png"
                      alt="Egyptair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.elal.co.il/ELAL/Francais/AllAboutYourFlight/BeforeYourFlight/EnManageMyBooking.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/LY.png"
                      alt="EL AL"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.etihad.com/fr-fr/before-you-fly/check-in-online/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/EY.png"
                      alt="Etihad"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.flydubai.com/en/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/FZ.png"
                      alt="FLYDUBAI"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://booking.flyernest.com/SearchResPax.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/EG.png"
                      alt="FlyErnest"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://booking.flynas.com/#/wci/search"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/XY.png"
                      alt="FlyNas"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://www.germania.ch/fr/voler/a-laeroport/enregistrement-en-ligne/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/GM.png"
                      alt="Germania FLUG"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.gulfair.com/English/info/Checkin/Pages/WebCheck-in.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/GF.png"
                      alt="Gulf Air"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://booking.hkexpress.com/manage/checkin.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/UO.png"
                      alt="HKG Express"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.icelandair.fr/information/before-you-go/online-checkin/"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/FI.png"
                      alt="Icelandair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://www.luxair.lu/fr/checkin"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/LG.png"
                      alt="Luxair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.malaysiaairlines.com/hq/en.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/MH.png"
                      alt="Malaysian"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://checkin.si.amadeus.net/1ASIHSSCWEBOA/sscwoa/checkin"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/OA.png"
                      alt="Olympic Air"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.omanair.com/en#"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/WY.png"
                      alt="Oman Air"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.flypgs.com/fr/default.aspx"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/PC.png"
                      alt="Pegasus"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.philippineairlines.com/en/ph/home"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/PR.png"
                      alt="Philippine Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.pobeda.aero/en/services/online_registration"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/DP.png"
                      alt="Pobeda"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://cki.qatarairways.com/cki-web/pages/search.xhtml"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/QR.png"
                      alt="Qatar Airways"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="http://www.royalairmaroc.com/Fr/E-services/Enregistrement_en_ligne_1220_4409.html"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/AT.png"
                      alt="Royal Air Maroc"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.flysas.com/fr-fr/checkin"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SK.png"
                      alt="SAS"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.flyskywork.com/fr/web-check-in"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/SX.png"
                      alt="Skywork"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.sunexpress.com/fr/avant-le-voyage/enregistrement-en-ligne"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/XQ.png"
                      alt="Sunexpress"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://www.swiss.com/es/fr/Login"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/LX.png"
                      alt="Swiss International Air Lins"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.tuifly.be/fr/my_zone"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TB.png"
                      alt="TUI Belgium"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://booking.tigerair.com/WebCheckIn.aspx?culture=en-GB&gaculture=SGEN"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TR.png"
                      alt="Tiger"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="http://www.transavia.com/hv/fr-FR/enregistrement-sur-internet"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TO.png"
                      alt="Transavia"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <a
                    href="https://www.turkishairlines.com/fr-fr/flights/manage-booking/#tcm97-2445"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/TK.png"
                      alt="Turkish Airlines"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.united.com/travel/checkin/start.aspx?LangCode=fr"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/UA.png"
                      alt="United"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://www.vivaaerobus.com/en/my-flight?fromUrl=/en/my-flight/print-boarding-pass"
                    target="_blank"
                  >
                    <v-img
                      src="@/assets/img/airlines-logos/VB.png"
                      alt="Viva Aerobus"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
                <v-col>
                  <a
                    href="https://wizzair.com/fr-fr/informations-et-services/informations-de-reservation/enregistrement-et-embarquement#/"
                    target="_blank"
                  >
                    <v-img
                      src="//images.trvl-media.com/media/content/expaus/images/airlines-logo/wizzairlinelogo.png"
                      alt="Wizzair"
                      height="50px"
                      contain
                    />
                  </a>
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="article">
            <h2>{{ $t('partners-conditions.baggage.title') }}</h2>
            <p>{{ $t('partners-conditions.baggage.text') }}</p>
          </div>

          <div class="article">
            <h2>{{ $t('partners-conditions.low-cost-carriers.title') }}</h2>
            <p>{{ $t('partners-conditions.low-cost-carriers.text.1') }}</p>
            <p>{{ $t('partners-conditions.low-cost-carriers.text.2') }}</p>
            <p>{{ $t('partners-conditions.low-cost-carriers.text.3') }}</p>
          </div>

          <div class="article">
            <h2>{{ $t('partners-conditions.regular-carriers.title') }}</h2>
            <p>{{ $t('partners-conditions.regular-carriers.text.1') }}</p>
            <p>{{ $t('partners-conditions.regular-carriers.text.2') }}</p>
            <p>{{ $t('partners-conditions.regular-carriers.text.3') }}</p>
            <p>{{ $t('partners-conditions.regular-carriers.text.4') }}</p>
          </div>

          <div class="article">
            <h2>{{ $t('partners-conditions.mandatory-travel-documents.title') }}</h2>
            <p>
              <span>{{ $t('partners-conditions.mandatory-travel-documents.text.1') }}</span>
              <a
                href="https://www.diplomatie.gouv.fr/fr/conseils-aux-voyageurs/"
                target="_blank"
              >{{ $t('partners-conditions.mandatory-travel-documents.text.1-link') }}</a>
            </p>
            <p>{{ $t('partners-conditions.mandatory-travel-documents.text.2') }}</p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Cgv',
  computed: {
    dialog: {
      get () {
        return this.$store.state.general.termsAndConditionsDialog
      },
      set (newVal) {
        this.$store.commit('general/changeTermsAndConditionsDialog', newVal)
      }
    }
  }
}
</script>

<style scoped>
  .headline {
    color: white;
  }

  .section {
    margin-top: 16px !important;
    margin-left: 4px !important;
  }

  h1 {
    padding-bottom: 17px;
  }
  h2 {
    padding-bottom: 7px;
  }
  h3 {
    padding-bottom: 7px;
  }
  .sub-section {
    margin-top: 16px !important;
    margin-left: 8px !important;
  }

  .sub-sub-section {
    margin-top: 16px !important;
    margin-left: 12px !important;
  }
</style>
